import { HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCheckbox, MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { ConfirmDialogModel, ConfirmDialogPopupComponent, convertTreeToList, CrudService, currentComponentPageBasedPermissionsSelector$, CustomDirectiveConfig, IApplicationResponse, ModulesBasedApiSuffix, OtherService, PermissionTypes, PERMISSION_RESTRICTION_ERROR, prepareGetRequestHttpParams, prepareRequiredHttpParams, PrimengConfirmDialogPopupComponent, ResponseMessageTypes, RxjsService, setRequiredValidator, SnackbarService, calculateBOMPrice, toRoundOffWithMathRound, calculateSubTotalBOMPrice, calculateVatTotalBOMPrice } from '@app/shared';
import { BillOfMaterialModel, StockCodeDescriptionFormArrayModel, StockCodeDescriptionModel } from '@modules/customer/models/bill-of-material.model';
import { CUSTOMER_COMPONENT } from '@modules/customer/shared';
import { EventMgntModuleApiSuffixModels } from '@modules/event-management';
import { loggedInUserData } from '@modules/others';
import { UserLogin } from '@modules/others/models';
import { TechnicalMgntModuleApiSuffixModels } from '@modules/technical-management/shared/enum.ts/technical.enum';
import { select, Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { combineLatest, forkJoin, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { DiscountOnWarrantyMaintenanceModalComponent, ServiceForDiscountModalComponent } from '..';
import { CustomerDecoderAddDialogComponent } from '../../../customer-management/customer-decoder/customer-decoder-add-dialog/customer-decoder-add-dialog.component';
import { CustomerZoneAddEditComponent } from '../../../customer-management/customer-zone/customer-zone-add-edit.component';
import { BillOfMaterialScanModalComponent } from '../bill-of-material-scan-modal';
import { BillOfMaterialValidationModalComponent } from '../bill-of-material-validation-modal';
import { BillOfMaterialZoneModalComponent } from '../bill-of-material-zone-modal';
import { NkaDoaRequestDialogComponent } from '../nka-doa-request-dialog/nka-doa-request-dialog.component';
import { PrCallDoaRequestDialogComponent } from '../pr-call-doa-request-dialog/pr-call-doa-request-dialog.component';

@Component({
  selector: 'app-bill-of-material-update',
  templateUrl: './bill-of-material-update.component.html',
  styleUrls: ['./bill-of-material-update.component.scss']
})
export class BillOfMaterialUpdateComponent implements OnInit {

  billOfMaterialForm: FormGroup;
  stockCodeDescriptionForm: FormGroup;
  billOfMaterialModel: any = {};
  status: any = [];
  userData: UserLogin;
  customerId: string;
  quotationVersionId: string;
  callInitiationId: string;
  isLoading: boolean;
  @ViewChild('selectAll', { static: false }) selectAll: MatCheckbox;
  selectedCheckBox = '';
  selectedCheckBoxBOMArray = [];
  isADecimalOnly = new CustomDirectiveConfig({ isADecimalOnly: true });
  numberConfig = new CustomDirectiveConfig({ isANumberOnly: true });
  standardTax: any;
  serialNumberError = false;
  stockTypeList = [
    { value: 'Y', displayName: 'Y' },
    { value: 'M', displayName: 'M' }
  ];
  // variables for auto select
  isStockCodeBlank: boolean = false;
  isStockDescriptionSelected: boolean = false;
  isStockOrderClear: boolean = false;
  stockCodeErrorMessage: any = '';
  showStockCodeError: boolean = false;
  isStockError: boolean = false;
  StockDescErrorMessage: any = '';
  showStockDescError: boolean = false;
  isStockDescError: boolean = false;
  isFeedback: any;
  filteredStockCodes = [];
  filteredStockDescription: any = [];
  stockExistError = false;
  callType = '';
  warrantyMaintenanceDetail = [];
  appointmentId: string = '';
  appointmentLogId: string = '';
  openKitDetailsDialog: boolean = false;
  modalDetails: any;
  stockCode: any;
  customerAddressId: any
  alertDialog: boolean = false
  alertMsg: string = '';
  serialNumbersData: any = [];
  serialNumberDataLocally = [];
  openSerialNumbersDialog = false;
  goodsReturnData: any = {};
  isVoid: boolean = false;
  isEscalateSubmit: boolean = false;
  TechnicialCallDiscountRequestApprovalId;
  isGRVConfirmationDialog: boolean = false;
  isScanServiceCallDialog: boolean = false;
  newCallInitiationId: string;
  searchScannedItemResponse: any;
  isServiceCallSumbmit: boolean;
  isAutoSaveEnable: boolean = true;
  isUpselling: boolean;
  isCounterSale: boolean;
  actionPermissionObj: any;
  isNKACustomer: boolean;
  jobCardAcceptanceSubscription: any;
  partitionId: string;
  discountTimer: any;// wait some times to open doa approval flow
  deleteStockCodeDialog: any;
  isInstallPreCheck: boolean;
  previousLaborCharge: any = {};
  fromPage: string = '';

  constructor(private formBuilder: FormBuilder,
    private crudService: CrudService,
    public dialogService: DialogService,
    private rxjsService: RxjsService,
    private store: Store<AppState>,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private snackbarService: SnackbarService,
    private otherService: OtherService) {
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.userData = userData;
    });
    this.customerId = this.activatedRoute.snapshot.queryParams.customerId;
    this.customerAddressId = this.activatedRoute.snapshot.queryParams.customerAddressId;
    this.partitionId = this.activatedRoute.snapshot.queryParams?.partitionId;
    this.quotationVersionId = this.activatedRoute.snapshot.queryParams.quotationVersionId;
    this.callInitiationId = this.activatedRoute.snapshot.queryParams.callInitiationId;
    this.callType = this.activatedRoute.snapshot.queryParams.callType;
    this.appointmentId = this.activatedRoute.snapshot.queryParams.appointmentId;
    this.appointmentLogId = this.activatedRoute.snapshot.queryParams.appointmentLogId;
    this.isFeedback = this.activatedRoute.snapshot.queryParams?.isFeedback == 'true';
    this.isInstallPreCheck = this.activatedRoute.snapshot.queryParams?.isInstallPreCheck == 'true';
    this.isUpselling = this.activatedRoute.snapshot.queryParams?.isUpselling == 'true';
    this.isCounterSale = this.activatedRoute.snapshot.queryParams?.isCounterSale == 'true';
    this.isNKACustomer = this.activatedRoute.snapshot.queryParams?.isNKACustomer == 'true';
    this.fromPage = this.activatedRoute.snapshot.queryParams.fromPage;
    this.isVoid = (this.activatedRoute.snapshot.queryParams?.isVoid && this.activatedRoute.snapshot.queryParams?.isVoid == 'true') ? true : false;
    this.TechnicialCallDiscountRequestApprovalId = this.activatedRoute.snapshot.queryParams.TechnicialCallDiscountRequestApprovalId;
  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData();
    this.createBillOfMaterialForm();
    this.createStockCodeDescriptionForm();
    this.getBillOfMaterialData();
    this.onFormValueChanges();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(currentComponentPageBasedPermissionsSelector$),]
    ).subscribe((response) => {
      let permission = response[0][CUSTOMER_COMPONENT.CUSTOMER]?.find(el => el?.menuName == CUSTOMER_COMPONENT.CUSTOMER_DASHBOARD);
      if (permission) {
        let techPermission = convertTreeToList([permission?.subMenu?.find(el => el?.menuName == CUSTOMER_COMPONENT.TECHNICAL)]);
        const objName = this.callType == '1' ? CUSTOMER_COMPONENT.INSTALLATION : this.callType == '2' ? CUSTOMER_COMPONENT.SERVICE :
          this.callType == '3' ? CUSTOMER_COMPONENT.SPECIAL_PROEJCT : '---';
        const callActionPermissionObj = techPermission?.find(el => el?.[objName])?.[objName];
        if (callActionPermissionObj) {
          const quickActionPermissionObj = callActionPermissionObj?.find(el => el?.menuName == PermissionTypes.QUICK_ACTION);
          if (quickActionPermissionObj) {
            this.actionPermissionObj = quickActionPermissionObj?.subMenu?.find(el => el?.menuName == CUSTOMER_COMPONENT.BILL_OF_MATERIALS);
          }
        }
      }
    });
  }

  getBOMActionPermission(actionTypeMenuName) {
    return this.actionPermissionObj?.subMenu?.find(el => el?.menuName == actionTypeMenuName);
  }

  getTitle() {
    return this.callType == '1' && this.billOfMaterialModel?.isDealerCall ? 'Dealer' : this.callType == '1' ? 'Installation' : this.callType == '2' ? 'Service' :
      this.callType == '3' ? 'Special Projects' : '';
  }

  onCalculateDiffAmt(value) {
    let diffAmount = this.billOfMaterialForm.get('targetOrderAmount').value - value;
    this.billOfMaterialForm.get('differenceAmount').setValue(this.otherService.transformDecimal(-Math.abs(diffAmount)));
    this.billOfMaterialForm.get('totalAmount').setValue(value);
  }

  onFormValueChanges() {
    this.billOfMaterialForm.get('bomInvoice.totalAmount').valueChanges.subscribe(value => {
      if (value?.toString()) {
        value = value ? this.otherService.transformCurrToNum(value) : 0;
      }
      if (value > 0) {
        this.onCalculateDiffAmt(value);
      } else if (!value) {
        value = 0;
        if (this.billOfMaterialModel['isPRCall'] || this.billOfMaterialModel['isSaveOffer']) {
          let billOfMaterialItemsFormArray = this.billOfMaterialItemsFormArray;
          let prCallData = billOfMaterialItemsFormArray.controls.find(element => (element.get('itemId').value == this.billOfMaterialModel['prCallDiscountItemId'] && this.billOfMaterialModel['isPRCall']) ||
            (element.get('itemId').value == this.billOfMaterialModel['saveOfferDiscountItemId'] && this.billOfMaterialModel['isSaveOffer']));
          if (prCallData) {
            value = value + Math.abs(prCallData.get('subTotal').value);
          }
        }
        let diffAmount = this.billOfMaterialForm.get('targetOrderAmount').value - value;
        this.billOfMaterialForm.get('differenceAmount').setValue(this.otherService.transformDecimal(-Math.abs(diffAmount)));
        if (this.billOfMaterialModel['isPRCall'] || this.billOfMaterialModel['isSaveOffer']) {
          this.billOfMaterialForm.get('totalAmount').setValue(0);
        } else {
          this.billOfMaterialForm.get('totalAmount').setValue(this.billOfMaterialForm.get('bomInvoice.totalAmount').value);
        }
      } else if (value < 0) {
        this.onCalculateDiffAmt(value);
      }
    });
    // Auto select stock code and description and stock type
    this.stockCodeDescriptionForm.get('stockType').valueChanges.subscribe(value => {
      this.stockCodeDescriptionForm.get('stockCode').setValue('', { emitEvent: false });
      this.stockCodeDescriptionForm.get('stockDescription').setValue('', { emitEvent: false });
      this.stockExistError = false;
    });
    this.stockCodeDescriptionForm.get('stockCode').valueChanges.pipe(debounceTime(100), distinctUntilChanged(),
      switchMap(searchText => {
        searchText = searchText == null ? searchText : searchText.trim();
        this.isStockDescError = false
        this.StockDescErrorMessage = '';
        this.showStockDescError = false;
        this.filteredStockDescription = [];
        this.stockExistError = false;
        if (this.isStockError == false) {
          this.stockCodeErrorMessage = '';
          this.showStockCodeError = false;
        } else {
          this.isStockError = false;
        }
        if (searchText != null && this.stockCodeDescriptionForm.get('stockType').value != '') {
          if (this.isStockCodeBlank == false) {
            this.stockCodeDescriptionForm.get('stockDescription').reset(null, { emitEvent: false });
            this.stockCodeDescriptionForm.get('stockUnitPriceExcl').reset(null, { emitEvent: false });
            this.stockCodeDescriptionForm.get('stockRequestedQty').reset(null, { emitEvent: false });
          } else {
            this.isStockCodeBlank = false;
          }
          if (!searchText) {
            if (searchText === '') {
              this.stockCodeErrorMessage = '';
              this.showStockCodeError = false;
              this.isStockError = false;
            } else {
              this.stockCodeErrorMessage = 'Stock code is not available in the system';
              this.showStockCodeError = true;
              this.isStockError = true;
            }
            if (this.stockCodeDescriptionForm.get('stockCode').value == '') {
              this.stockCodeDescriptionForm.get('stockCode').markAsTouched();
            }
            this.rxjsService.setGlobalLoaderProperty(false);
            return this.filteredStockCodes = [];
          } else {
            let searchStockObject = Object.assign({},
              searchText == null ? null : { ItemCode: searchText },
              this.callInitiationId ? { CallInitiationId: this.callInitiationId } : null,
              this.stockCodeDescriptionForm.get('stockType').value == null ? null : { StockType: this.stockCodeDescriptionForm.get('stockType').value },
              this.billOfMaterialModel['districtId'] == null ? null : { DistrictId: this.billOfMaterialModel['districtId'] },
              this.billOfMaterialModel['warehouseId'] == null ? null : { WarehouseId: this.billOfMaterialModel['warehouseId'] },
              this.billOfMaterialModel['itemPricingConfigId'] == null ? null : { itemPricingConfigId: this.billOfMaterialModel['itemPricingConfigId'] },
              this.billOfMaterialModel['technicianId'] == null ? null : { TechnicianId: this.billOfMaterialModel['technicianId'] });
            if (this.stockCodeDescriptionForm.get('stockType').value?.toLowerCase() == 'm') {
              this.stockCodeErrorMessage = '';
              this.showStockCodeError = false;
              this.isStockError = false;
              return this.crudService.get(
                ModulesBasedApiSuffix.TECHNICIAN,
                TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_SEARCH_STOCK_DETAILS_TECHNICIAN, null, true,
                prepareGetRequestHttpParams(null, null, searchStockObject))
            } else {
              this.stockCodeErrorMessage = '';
              this.showStockCodeError = false;
              this.isStockError = false;
              return this.crudService.get(
                ModulesBasedApiSuffix.TECHNICIAN,
                TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_SEARCH_STOCK_DETAILS_TECHNICIAN, null, true,
                prepareGetRequestHttpParams(null, null, searchStockObject))
            }
          }
        } else {
          if (this.stockCodeDescriptionForm.get('stockType').value == '') {
            this.stockCodeDescriptionForm.get('stockType').markAsTouched();
          }
          this.rxjsService.setGlobalLoaderProperty(false);
          return this.filteredStockCodes = [];
        }
      })).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.resources?.length > 0) {
          this.onPatchStockItemArray(response);
          this.stockCodeErrorMessage = '';
          this.showStockCodeError = false;
          this.isStockError = false;
        } else if (this.billOfMaterialModel['technicianId'] && response?.resources?.length == 0) {
          this.filteredStockCodes = [];
          this.stockCodeErrorMessage = 'Stock code is not available against technician stock location';
          this.showStockCodeError = true;
          this.isStockError = true;
          this.clearFormArray(this.stockAddItemFormarry);
          this.stockCodeDescriptionForm.markAsTouched();
        } else {
          this.filteredStockCodes = [];
          this.stockCodeErrorMessage = 'Stock code is not available in the system';
          this.showStockCodeError = true;
          this.isStockError = true;
          this.clearFormArray(this.stockAddItemFormarry);
          this.stockCodeDescriptionForm.markAsTouched();
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
    this.stockCodeDescriptionForm.get('stockDescription').valueChanges.pipe(debounceTime(100), distinctUntilChanged(),
      switchMap(searchText => {
        searchText = searchText == null ? searchText : searchText.trim();
        this.stockExistError = false;
        if (searchText != null && this.stockCodeDescriptionForm.get('stockType').value != '') {
          this.stockCodeErrorMessage = '';
          this.showStockCodeError = false;
          this.isStockError = false;
          this.filteredStockCodes = [];
          if (this.isStockDescError == false) {
            this.StockDescErrorMessage = '';
            this.showStockDescError = false;
          } else {
            this.showStockDescError = false;
          }
          if (this.isStockDescriptionSelected == false) {
            this.stockCodeDescriptionForm.get('stockCode').reset(null, { emitEvent: false });
            this.stockCodeDescriptionForm.get('stockUnitPriceExcl').reset(null, { emitEvent: false });
            this.stockCodeDescriptionForm.get('stockRequestedQty').reset(null, { emitEvent: false });
          } else {
            this.isStockDescriptionSelected = false;
          }
          if (!searchText) {
            if (searchText === '') {
              this.StockDescErrorMessage = '';
              this.showStockDescError = false;
              this.isStockDescError = false;
            } else {
              this.StockDescErrorMessage = 'Stock description is not available in the system';
              this.showStockDescError = true;
              this.isStockDescError = true;
            }
            if (this.stockCodeDescriptionForm.get('stockDescription').value == '') {
              this.stockCodeDescriptionForm.get('stockDescription').markAsTouched();
            }
            this.rxjsService.setGlobalLoaderProperty(false);
            return this.filteredStockDescription = [];
          } else {
            let searchStockDescObject = Object.assign({},
              searchText == null ? null : { displayName: searchText, },
              this.callInitiationId ? { CallInitiationId: this.callInitiationId } : null,
              this.stockCodeDescriptionForm.get('stockType').value == null ? null : { StockType: this.stockCodeDescriptionForm.get('stockType').value },
              this.billOfMaterialModel['districtId'] == null ? null : { DistrictId: this.billOfMaterialModel['districtId'] },
              this.billOfMaterialModel['warehouseId'] == null ? null : { WarehouseId: this.billOfMaterialModel['warehouseId'] },
              this.billOfMaterialModel['itemPricingConfigId'] == null ? null : { itemPricingConfigId: this.billOfMaterialModel['itemPricingConfigId'] },
              this.billOfMaterialModel['technicianId'] == null ? null : { TechnicianId: this.billOfMaterialModel['technicianId'] });
            if (this.stockCodeDescriptionForm.get('stockType').value?.toLowerCase() == 'm') {
              this.StockDescErrorMessage = '';
              this.showStockDescError = false;
              this.isStockDescError = false;
              return this.crudService.get(
                ModulesBasedApiSuffix.TECHNICIAN,
                TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_SEARCH_STOCK_DETAILS_TECHNICIAN, null, true,
                prepareGetRequestHttpParams(null, null, searchStockDescObject))
            } else {
              this.StockDescErrorMessage = '';
              this.showStockDescError = false;
              this.isStockDescError = false;
              return this.crudService.get(
                ModulesBasedApiSuffix.TECHNICIAN,
                TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_SEARCH_STOCK_DETAILS_TECHNICIAN, null, true,
                prepareGetRequestHttpParams(null, null, searchStockDescObject))
            }
          }
        } else {
          if (this.stockCodeDescriptionForm.get('stockType').value == '') {
            this.stockCodeDescriptionForm.get('stockType').markAsTouched();
          }
          this.rxjsService.setGlobalLoaderProperty(false);
          return this.filteredStockDescription = [];
        }
      })).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.resources.length > 0) {
          this.onPatchStockItemArray(response);
          this.isStockDescriptionSelected = false;
          this.StockDescErrorMessage = '';
          this.showStockDescError = false;
          this.isStockDescError = false;
          this.stockCodeDescriptionForm.get('stockDescription').setValue('', { emitEvent: false });
          this.stockCodeDescriptionForm.get('stockDescription').markAsUntouched();
        } else if (this.billOfMaterialModel['technicianId'] && response?.resources?.length == 0) {
          this.onLoadStockFormArray();
          this.filteredStockDescription = [];
          this.isStockDescriptionSelected = false;
          this.StockDescErrorMessage = 'Stock description is not available against technician stock location';
          this.showStockDescError = true;
          this.isStockDescError = true;
          this.stockCodeDescriptionForm.markAsTouched();
        } else {
          this.onLoadStockFormArray();
          this.filteredStockDescription = [];
          this.isStockDescriptionSelected = false;
          this.StockDescErrorMessage = 'Stock description is not available in the system';
          this.showStockDescError = true;
          this.isStockDescError = true;
          this.clearFormArray(this.stockAddItemFormarry);
          this.stockCodeDescriptionForm.markAsTouched();
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
    this.billOfMaterialForm.get('isStock').valueChanges.subscribe(value => {
      if (value) {
        this.billOfMaterialForm.get('isDiscount').setValue(false);
        this.stockCodeDescriptionForm.get('stockType').setValue('Y');
        this.onLoadStockFormArray();
      } else {
        this.stockCodeDescriptionForm.get('stockType').setValue('');
        this.clearFormArray(this.stockAddItemFormarry);
        this.stockCodeDescriptionForm.markAsTouched();
      }
    });
    this.billOfMaterialForm.get('isDiscount').valueChanges.subscribe(value => {
      if (value) {
        this.billOfMaterialForm.get('isStock').setValue(false);
        this.stockCodeDescriptionForm.get('stockType').setValue('M');
        this.onLoadStockFormArray();
      } else {
        this.stockCodeDescriptionForm.get('stockType').setValue('');
        this.clearFormArray(this.stockAddItemFormarry);
        this.stockCodeDescriptionForm.markAsTouched();
      }
    });
  }

  onLoadStockFormArray() {
    let searchStockDescObject = Object.assign({},
      this.callInitiationId ? { CallInitiationId: this.callInitiationId } : null,
      this.stockCodeDescriptionForm.get('stockType').value == null ? null : { stockType: this.stockCodeDescriptionForm.get('stockType').value },
      this.billOfMaterialModel['districtId'] == null ? null : { districtId: this.billOfMaterialModel['districtId'] },
      this.billOfMaterialModel['warehouseId'] == null ? null : { warehouseId: this.billOfMaterialModel['warehouseId'] },
      this.billOfMaterialModel['itemPricingConfigId'] == null ? null : { itemPricingConfigId: this.billOfMaterialModel['itemPricingConfigId'] },
      this.billOfMaterialModel['technicianId'] == null ? null : { technicianId: this.billOfMaterialModel['technicianId'] });
    this.crudService.get(
      ModulesBasedApiSuffix.TECHNICIAN,
      TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_SEARCH_STOCK_DETAILS_TECHNICIAN, null, true,
      prepareGetRequestHttpParams(null, null, searchStockDescObject))
      .subscribe((res: IApplicationResponse) => {
        this.rxjsService.setGlobalLoaderProperty(false);
        if (res?.isSuccess && res?.statusCode == 200) {
          this.onPatchStockItemArray(res);
        }
      });
  }

  onPatchStockItemArray(res) {
    this.clearFormArray(this.stockAddItemFormarry);
    res?.resources.forEach(el => {
      this.initFormArray({
        id: el?.id,
        stockType: el?.stockType,
        stockCode: el?.itemCode,
        stockDescription: el?.displayName,
        stockUnitPriceExcl: el?.costPrice,
        stockRequestedQty: '',
        stockTypeId: el?.stockTypeId,
        itemId: el?.id,
        kitConfigId: el?.kitConfigId,
        kitTypeName: el?.kitTypeName,
        systemTypeId: el?.systemTypeId,
        itemPricingConfigId: el?.itemPricingConfigId,
        isNotSerialized: el?.isNotSerialized,
        costPrice: el?.costPrice,
        displayName: el?.displayName,
        isDecoder: el?.isDecoder,
      });
    })
    this.stockCodeDescriptionForm.markAsUntouched();
  }

  initFormArray(stockCodeDescriptionFormArrayModel?: StockCodeDescriptionFormArrayModel) {
    let stockCodeDescriptionModel = new StockCodeDescriptionFormArrayModel(stockCodeDescriptionFormArrayModel);
    let stockCodeDescriptionFormArray = this.formBuilder.group({});
    Object.keys(stockCodeDescriptionModel).forEach((key) => {
      stockCodeDescriptionFormArray.addControl(key, new FormControl(stockCodeDescriptionModel[key]));
    });
    stockCodeDescriptionFormArray = setRequiredValidator(stockCodeDescriptionFormArray,
      ["stockRequestedQty"]);
    stockCodeDescriptionFormArray.get('stockType').disable();
    stockCodeDescriptionFormArray.get('stockCode').disable();
    stockCodeDescriptionFormArray.get('stockDescription').disable();
    stockCodeDescriptionFormArray.get('stockUnitPriceExcl').disable();
    stockCodeDescriptionFormArray.get('stockRequestedQty').setValidators([Validators.required, Validators.maxLength(5)]);
    stockCodeDescriptionFormArray.get('stockRequestedQty').updateValueAndValidity();
    this.stockAddItemFormarry.push(stockCodeDescriptionFormArray);
  }

  onValidateStockItemFormArray() {
    const arr = [];
    this.stockAddItemFormarry?.controls.forEach(el => {
      arr.push(el?.invalid);
    })
    return arr.every(el => el == true);
  }

  onValidateLighting() {
    const arr = [];
    this.stockAddItemFormarry?.controls.forEach(el => {
      if (this.billOfMaterialModel['lightningDiscountItemId'] == el?.get('id')?.value && el?.get('stockRequestedQty').value > 1) {
        arr.push(el?.invalid);
      }
    })
    return arr.every(el => el == true);
  }

  getStockItemAlreadyExist() {
    const arr = [];
    this.billOfMaterialItemsFormArray?.getRawValue()?.forEach(el => {
      this.stockAddItemFormarry?.getRawValue()?.forEach(el1 => {
        if (el.itemCode == el1.stockCode && el.IsDeleted == false && el1.stockRequestedQty) {
          arr.push(el.itemCode);
        }
      });
    })
    const returnText = arr.length ? arr?.join(", ") : '';
    return returnText;
  }

  getDiscountItemExist() {
    const arr = [];
    this.stockAddItemFormarry?.getRawValue()?.forEach(el => {
      const findYItem = this.billOfMaterialItemsFormArray?.getRawValue()?.filter(el => el?.stockType?.toLowerCase() == 'y');
      if (this.billOfMaterialModel?.technicianDiscountItems?.indexOf(el.itemId) > -1 && findYItem?.length == 0) {
        arr.push(el.itemId);
      }
    })
    return arr.length;
  }

  addBOMMultiToTable() {
    if (this.onValidateStockItemFormArray()) {
      this.stockAddItemFormarry?.markAllAsTouched();
      return;
    }
    if (!this.standardTax) {
      return this.snackbarService.openSnackbar("Tax not found");
    }
    if (this.getStockItemAlreadyExist()) {
      this.snackbarService.openSnackbar("Item has been added already");
      return;
    }
    this.stockAddItemFormarry?.controls.forEach(el => {
      if (el.invalid) {
        return;
      } else {
        let billOfMaterialItemsFormArray = this.billOfMaterialItemsFormArray;
        let billOfMaterialItemFormGroup = this.formBuilder.group({
          checkBillOfMaterial: false,
          IsDeleted: false,
          billOfMaterialItemId: '',
          billOfMaterialId: '',
          stockTypeId: el?.get('stockTypeId')?.value,
          stockType: el?.get('stockType')?.value,
          itemId: el?.get('itemId')?.value,
          itemCode: el?.get('stockCode')?.value,
          itemName: el?.get('stockDescription')?.value,
          invoice: 0,
          transfer: 0,
          used: 0,
          reserved: 0,
          request: 0,// +this.stockCodeDescriptionForm.get('stockRequestedQty').value,
          unitPrice: toRoundOffWithMathRound(+el?.get('stockUnitPriceExcl')?.value),
          subTotal: '',
          vATAmount: '',
          totalAmount: '',
          createdUserId: this.userData?.userId,
          modifiedUserId: this.userData?.userId,
          IsWarranty: false,
          WarrantyQty: 0, // check with backend developer
          kitConfigId: el?.get('kitConfigId')?.value,
          kitTypeName: el?.get('kitTypeName')?.value,
          systemTypeId: el?.get('systemTypeId')?.value,
          itemPricingConfigId: el?.get('itemPricingConfigId')?.value,
          isNotSerialized: el?.get('isNotSerialized')?.value,
        });
        if (el?.get('stockType').value.toLowerCase() == 'y') {
          if (el?.get('isNotSerialized').value) {
            billOfMaterialItemFormGroup.get('request').setValue(+el?.get('stockRequestedQty').value);
          } else if (this.billOfMaterialModel['lightningDiscountItemId'] == el?.get('id').value || this.getDiscountValueItems(el?.get('id').value)) {
            el?.get('stockRequestedQty').setValue(1);
            billOfMaterialItemFormGroup.get('request').setValue(+el?.get('stockRequestedQty').value);
          } else {
            billOfMaterialItemFormGroup.get('request').setValue(+el?.get('stockRequestedQty').value);
          }
        } else if (el?.get('stockType').value.toLowerCase() == 'm') {
          billOfMaterialItemFormGroup.get('used').setValue(1);
          el?.get('stockRequestedQty').setValue(1);
        }
        const result = calculateBOMPrice({
          qty: el?.get('stockRequestedQty').value, price: billOfMaterialItemFormGroup.get('unitPrice').value,
          taxPercent: this.standardTax, roundFn: toRoundOffWithMathRound
        });
        billOfMaterialItemFormGroup.get('subTotal').setValue(result?.subTotal);
        billOfMaterialItemFormGroup.get('vATAmount').setValue(result?.vatAmount);
        billOfMaterialItemFormGroup.get('totalAmount').setValue(result?.totalAmount);

        if (this.billOfMaterialModel['lightningDiscountItemId'] == el?.get('id').value || this.getDiscountValueItems(el?.get('id').value)) { // for lightning cover
          billOfMaterialItemFormGroup.get('unitPrice').setValue(typeof +billOfMaterialItemFormGroup.get('unitPrice').value == 'number'
            ? (this.otherService.transformDecimal(-Math.abs(billOfMaterialItemFormGroup.get('unitPrice').value))) : -Math.abs(billOfMaterialItemFormGroup.get('unitPrice').value));
          billOfMaterialItemFormGroup.get('subTotal').setValue(-Math.abs(billOfMaterialItemFormGroup.get('subTotal').value));
          billOfMaterialItemFormGroup.get('vATAmount').setValue(-Math.abs(billOfMaterialItemFormGroup.get('vATAmount').value));
          billOfMaterialItemFormGroup.get('totalAmount').setValue(-Math.abs(billOfMaterialItemFormGroup.get('totalAmount').value));
        }
        // if installation call, if current stock item's amount + previous total amount > target order amount then show
        // warning and dont allow to add stock item in grid else allow it to add
        // this only applicable to installation call
        if ((this.callType == '1' || this.isUpselling || this.isCounterSale) && !this.billOfMaterialModel?.isDealerCall && (+billOfMaterialItemFormGroup.get('totalAmount').value + +this.billOfMaterialForm.get('bomInvoice.totalAmount').value) > +this.billOfMaterialForm.get('targetOrderAmount').value) {
          this.searchScannedItemResponse = {
            itemId: el?.get('itemId')?.value,
            qty: el?.get('stockRequestedQty')?.value,
            itemPricingConfigId: el?.get('itemPricingConfigId')?.value,
          };
          this.isScanServiceCallDialog = true;
          return;
        }
        let bomsubTotal = +this.billOfMaterialForm.get('bomInvoice.subTotal').value + +billOfMaterialItemFormGroup.get('subTotal').value;
        let bomvATAmount = +this.billOfMaterialForm.get('bomInvoice.vatAmount').value + +billOfMaterialItemFormGroup.get('vATAmount').value;
        let bomtotalAmount = +this.billOfMaterialForm.get('bomInvoice.totalAmount').value + +billOfMaterialItemFormGroup.get('totalAmount').value;

        let differenceAmount = this.otherService.transformCurrToNum(this.billOfMaterialForm.get('differenceAmount').value);
        //condition for checking PR Call or Save offer call
        if (this.billOfMaterialModel['isPRCall'] == true || this.billOfMaterialModel['isSaveOffer'] == true) {
          //checking total amount is greater than differ amount
          if (+billOfMaterialItemFormGroup.get('subTotal').value > Math.abs(differenceAmount)) {
            //serviceCallRequestId is present
            if (this.billOfMaterialModel.serviceCallRequestId) {
              this.openPrCallDialogWithReqId(billOfMaterialItemFormGroup, el?.get('stockRequestedQty').value);
            } else {
              // this.openPrCallDialog(el, subTotal, totalAmount);
              let data = {
                stockType: this.stockCodeDescriptionForm?.get('stockType')?.value,
                billOfMaterialModel: this.billOfMaterialModel,
                standardTax: this.standardTax,
                userId: this.userData?.userId,
                newData: {
                  itemId: billOfMaterialItemFormGroup?.get('itemId').value,
                  stockCode: billOfMaterialItemFormGroup?.get('itemCode').value,
                  stockDesc: billOfMaterialItemFormGroup?.get('itemName').value,
                  stockQty: el?.get('stockRequestedQty').value,
                  stockUnitPriceExVat: billOfMaterialItemFormGroup?.get('unitPrice').value,
                  subTotalExclVat: billOfMaterialItemFormGroup?.get('subTotal').value,
                  subTotalInclVat: billOfMaterialItemFormGroup?.get('totalAmount').value,
                  itemPricingConfigId: el?.get('itemPricingConfigId').value
                },
              }
              this.openPRCallDynamicDialog(data);
            }
          } else {
            let prCallDetails = this.billOfMaterialItemsFormArray.controls.find(element => (element.get('itemId').value == this.billOfMaterialModel['prCallDiscountItemId'] && this.billOfMaterialModel['isPRCall']) ||
              (element.get('itemId').value == this.billOfMaterialModel['saveOfferDiscountItemId'] && this.billOfMaterialModel['isSaveOffer']));
            if (prCallDetails) {
              const unitPricePRDetails = Math.abs(prCallDetails.get('unitPrice').value) + +billOfMaterialItemFormGroup.get('unitPrice').value;
              prCallDetails.get('unitPrice').setValue(-Math.abs(toRoundOffWithMathRound(unitPricePRDetails)));
              const subTotalPRDetails = Math.abs(prCallDetails.get('subTotal').value) + +billOfMaterialItemFormGroup.get('subTotal').value;
              prCallDetails.get('subTotal').setValue(-Math.abs(toRoundOffWithMathRound(subTotalPRDetails)));
              const vatAmountPRDetails = Math.abs(prCallDetails.get('vATAmount').value) + +billOfMaterialItemFormGroup.get('vATAmount').value;
              prCallDetails.get('vATAmount').setValue(-Math.abs(toRoundOffWithMathRound(vatAmountPRDetails)));
              const totalAmountPRDetails = Math.abs(prCallDetails.get('totalAmount').value) + +billOfMaterialItemFormGroup.get('totalAmount').value
              prCallDetails.get('totalAmount').setValue(-Math.abs(toRoundOffWithMathRound(totalAmountPRDetails)));
              this.billOfMaterialForm.get('bomInvoice.totalAmount').setValue('R 0.00');
            }
            this.sortStockCodes(billOfMaterialItemFormGroup);
            this.resetStockDescForm();
          }
        } else if (this.isNKACustomer && +billOfMaterialItemFormGroup.get('totalAmount').value > Math.abs(differenceAmount)) { //For NKA customer
          this.crudService.get(
            ModulesBasedApiSuffix.TECHNICIAN,
            TechnicalMgntModuleApiSuffixModels.NKA_SERVICE_CALL_PURCHASE_ORDER,
            null, null, prepareRequiredHttpParams({ callInitiationId: this.billOfMaterialModel.callInitiationId }))
            .subscribe((response: IApplicationResponse) => {
              if (response?.isSuccess && response?.statusCode == 200) {
                let data = {
                  stockType: this.stockCodeDescriptionForm?.get('stockType')?.value,
                  billOfMaterialModel: this.billOfMaterialModel,
                  tax: this.standardTax,
                  userId: this.userData?.userId,
                  newData: {
                    NKAPurchaseOrderRequestItemId: null,
                    NKAPurchaseOrderRequestId: null,
                    itemId: el?.get('itemId').value,
                    itemCode: el?.get('stockCode').value,
                    itemName: el?.get('stockDescription').value,
                    quantity: el?.get('stockRequestedQty').value,
                    unitPriceExclVat: el?.get('stockUnitPriceExcl').value,
                    subTotalExclVat: result?.subTotal,
                    subTotalInclVat: result?.totalAmount,
                    itemPricingConfigId: el?.get('itemPricingConfigId').value
                  },
                  response: response?.resources,
                }
                this.openNKADoaRequestDialog(data);
              }
              this.rxjsService.setGlobalLoaderProperty(false);
            })
        }
        else {
          // setting values for final row ie. BOM Invoice
          this.billOfMaterialForm.get('bomInvoice.subTotal').setValue(bomsubTotal ? toRoundOffWithMathRound(bomsubTotal) : 0);
          this.billOfMaterialForm.get('bomInvoice.vatAmount').setValue(bomvATAmount ? toRoundOffWithMathRound(bomvATAmount) : 0);
          this.billOfMaterialForm.get('bomInvoice.totalAmount').setValue(bomtotalAmount ? toRoundOffWithMathRound(bomtotalAmount) : 0);

          if (el?.get('stockDescription').value.toLowerCase() == 'servicing discount technical') {
            // For servicing discount technical, open approval pop up, get approval from 3 managers.
            // we dont perform any other calculations, we just patch unitPrice with stockUnitPriceExcl and others as 0.
            // after final approval values related to servicing discount technical will come from backend bom main GET api.
            // since we dont change final BOM Invoice calculations when we add servicing discount technical there is no
            // need of extra logic while removing servicing discount technical from Remove Stock.
            billOfMaterialItemFormGroup.get('unitPrice').patchValue(el.get('stockUnitPriceExcl').value);
            billOfMaterialItemFormGroup.get('subTotal').setValue('R 0.00');
            billOfMaterialItemFormGroup.get('vATAmount').setValue('R 0.00');
            billOfMaterialItemFormGroup.get('totalAmount').setValue('R 0.00');
          }
          if (this.billOfMaterialModel?.serviceLabourChargeItemId == el?.get('itemId').value) {
            this.onCalculateLaborChargeAPI();
          }
          if (!this.billOfMaterialModel['isPRCall'] && !this.billOfMaterialModel['isPRcallSaveOfferMaxCount'] && this.billOfMaterialModel?.serviceLabourChargeItemId != el?.get('itemId').value) {
            // Discount Warranties starts
            this.crudService.get(
              ModulesBasedApiSuffix.TECHNICIAN,
              TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_WARRANTY_CHECK,
              undefined,
              false,
              prepareGetRequestHttpParams('', '', {
                CallInitiationId: this.callInitiationId,
                ItemId: el?.get('itemId').value,
                StockTypeId: el?.get('stockTypeId').value
              })
            ).subscribe((response: IApplicationResponse) => {
              this.rxjsService.setGlobalLoaderProperty(false);
              if (response.isSuccess == true && response.statusCode == 200) {
                // If this condition is true or stock code has isWarranty then we add 3 prices of that stock code
                // to BOM.Invoice row and also in Warranty Discount row ie. 2 rows
                // After adding, we deduct prices of Warranty Discount row from BOM.Invoice row
                // since request and warrantyQty is same
                // logic for changed warranty quantity is handled in openDiscountWarranties()
                let discountStockDetails = billOfMaterialItemsFormArray.controls.find(element => element.get('itemId').value.toLowerCase() == response.resources['itemId'].toLowerCase());
                if (response.resources['isWarranty'] || response.resources['isDiscountMaintenance']) {
                  // We are setting value in other than Discount Warranty but for isWarranty >> true items
                  billOfMaterialItemFormGroup.get('IsWarranty').setValue(true);
                  billOfMaterialItemFormGroup.get('WarrantyQty').setValue(0);
                  this.warrantyMaintenanceDetail.push(billOfMaterialItemFormGroup);
                }
                // For discount warranty only after serial no scan so commented this lines
                // if (discountStockDetails == undefined && (response.resources['isWarranty'] || response.resources['isDiscountMaintenance'])) {
                //   let warsubTotal = result?.subTotal;
                //   let warVatAmount = result?.vatAmount;
                //   let warTotalAmount = result?.totalAmount;
                //   if (+response?.resources?.warrantyQty <= +el?.get('stockRequestedQty').value) {
                //     billOfMaterialItemFormGroup.get('WarrantyQty').setValue(+response?.resources?.warrantyQty);
                //     warsubTotal = +billOfMaterialItemFormGroup.get('WarrantyQty').value * +billOfMaterialItemFormGroup.get('unitPrice').value;
                //     warVatAmount = +warsubTotal * (this.standardTax / 100);
                //     warTotalAmount = +warsubTotal + +billOfMaterialItemFormGroup.get('vATAmount').value;
                //   }
                //   // Related to Discount Warrenties 1st time
                //   let billOfMaterialWarrantyItemFormGroup = this.formBuilder.group({
                //     checkBillOfMaterial: false,
                //     IsDeleted: false,
                //     billOfMaterialItemId: '',
                //     billOfMaterialId: '',
                //     stockTypeId: response.resources['stockTypeId'],
                //     stockType: response.resources['stockType'],
                //     itemId: response.resources['itemId'],
                //     itemCode: response.resources['itemCode'],
                //     itemName: response.resources['itemName'],
                //     invoice: 0,
                //     transfer: 0,
                //     used: 0,
                //     reserved: 0,
                //     request: 0,// +billOfMaterialItemFormGroup.get('request').value,
                //     unitPrice: -Math.abs(this.otherService.transformCurrToNum(billOfMaterialItemFormGroup.get('unitPrice').value)).toFixed(2),
                //     subTotal: -Math.abs(+warsubTotal).toFixed(2),
                //     vATAmount: vatAmount?.toString() ? -Math.abs(+warVatAmount).toFixed(2) : 0,
                //     totalAmount: -Math.abs(+warTotalAmount).toFixed(2),
                //     createdUserId: this.userData?.userId,
                //     modifiedUserId: this.userData?.userId,
                //     IsWarranty: false,
                //     WarrantyQty: null
                //   });
                //   if (el?.get('stockType').value.toLowerCase() == 'y') {
                //     if (el?.get('isNotSerialized').value) {
                //       if (+response?.resources?.warrantyQty >= +el?.get('stockRequestedQty').value) {
                //         billOfMaterialWarrantyItemFormGroup.get('WarrantyQty').setValue(+el?.get('stockRequestedQty').value);
                //         billOfMaterialItemFormGroup.get('WarrantyQty').setValue(+el?.get('stockRequestedQty').value);
                //       } else if (+response?.resources?.warrantyQty < +el?.get('stockRequestedQty').value) {
                //         billOfMaterialWarrantyItemFormGroup.get('WarrantyQty').setValue(+response?.resources?.warrantyQty);
                //         billOfMaterialItemFormGroup.get('WarrantyQty').setValue(+response?.resources?.warrantyQty);
                //       }
                //     } else if (+response?.resources?.warrantyQty >= +el?.get('stockRequestedQty').value) {
                //       billOfMaterialWarrantyItemFormGroup.get('WarrantyQty').setValue(+el?.get('stockRequestedQty').value);
                //       billOfMaterialItemFormGroup.get('WarrantyQty').setValue(+el?.get('stockRequestedQty').value);
                //     } else if (+response?.resources?.warrantyQty < +el?.get('stockRequestedQty').value) {
                //       billOfMaterialWarrantyItemFormGroup.get('WarrantyQty').setValue(+response?.resources?.warrantyQty);
                //       billOfMaterialItemFormGroup.get('WarrantyQty').setValue(+response?.resources?.warrantyQty);
                //     }
                //   }
                //   if (el?.get('stockType').value.toLowerCase() == 'm') {
                //     billOfMaterialWarrantyItemFormGroup.get('used').setValue(+el?.get('stockRequestedQty').value);
                //   }
                //   if (response.resources['stockType'].toLowerCase() == 'm') {
                //     if (+response?.resources?.warrantyQty >= +el?.get('stockRequestedQty').value) {
                //       billOfMaterialWarrantyItemFormGroup.get('used').setValue(+el?.get('stockRequestedQty').value);
                //     } else {
                //       billOfMaterialWarrantyItemFormGroup.get('used').setValue(+response?.resources?.warrantyQty);
                //     }
                //   }
                //   billOfMaterialItemsFormArray.push(billOfMaterialWarrantyItemFormGroup);
                //   // setting values for final row ie. BOM Invoice
                //   this.billOfMaterialForm.get('bomInvoice.subTotal').setValue((this.billOfMaterialForm.get('bomInvoice.subTotal').value - Math.abs(billOfMaterialWarrantyItemFormGroup.get('subTotal').value)).toFixed(2));
                //   this.billOfMaterialForm.get('bomInvoice.vatAmount').setValue((this.billOfMaterialForm.get('bomInvoice.vatAmount').value - Math.abs(billOfMaterialWarrantyItemFormGroup.get('vATAmount').value)).toFixed(2));
                //   this.billOfMaterialForm.get('bomInvoice.totalAmount').setValue((this.billOfMaterialForm.get('bomInvoice.totalAmount').value - Math.abs(billOfMaterialWarrantyItemFormGroup.get('totalAmount').value)).toFixed(2));
                // } else if (discountStockDetails != undefined && (response.resources['isWarranty'] || response.resources['isDiscountMaintenance'])) {
                //   let billOfMaterialWarrantyItemFormGroup = this.formBuilder.group(billOfMaterialItemFormGroup.getRawValue());
                //   if (+response?.resources?.warrantyQty <= +el?.get('stockRequestedQty').value) {
                //     billOfMaterialItemFormGroup.get('WarrantyQty').setValue(+response?.resources?.warrantyQty);
                //   }
                //   let warSubTotal = +billOfMaterialWarrantyItemFormGroup.get('WarrantyQty').value * +billOfMaterialItemFormGroup.get('unitPrice').value;
                //   let warVatAmount = +warSubTotal * (this.standardTax / 100);
                //   let warTotalAmount = +warSubTotal + +vatAmount;
                //   billOfMaterialWarrantyItemFormGroup?.get('subTotal').setValue(warSubTotal);
                //   billOfMaterialWarrantyItemFormGroup?.get('vATAmount').setValue(warVatAmount);
                //   billOfMaterialWarrantyItemFormGroup?.get('totalAmount').setValue(warTotalAmount);
                //   if (el?.get('stockType').value.toLowerCase() == 'y') {
                //     if (el?.get('isNotSerialized').value) {
                //       if (+response?.resources?.warrantyQty >= +el?.get('stockRequestedQty').value) {
                //         billOfMaterialItemFormGroup.get('WarrantyQty').setValue(+el?.get('stockRequestedQty').value);
                //       } else if (+response?.resources?.warrantyQty < +el?.get('stockRequestedQty').value) {
                //         billOfMaterialItemFormGroup.get('WarrantyQty').setValue(+response?.resources?.warrantyQty);
                //       }
                //     } else if (+response?.resources?.warrantyQty >= +el?.get('stockRequestedQty').value) {
                //       billOfMaterialItemFormGroup.get('WarrantyQty').setValue(+el?.get('stockRequestedQty').value);
                //     } else if (+response?.resources?.warrantyQty < +el?.get('stockRequestedQty').value) {
                //       billOfMaterialItemFormGroup.get('WarrantyQty').setValue(+response?.resources?.warrantyQty);
                //     }
                //   }
                //   // Related to Discount Warrenties other than 1st time
                //   discountStockDetails.get('used').setValue(((Math.abs(+discountStockDetails.get('used').value) + +billOfMaterialWarrantyItemFormGroup.get('WarrantyQty').value)));
                //   discountStockDetails.get('request').setValue(((Math.abs(+discountStockDetails.get('request').value) + +billOfMaterialWarrantyItemFormGroup.get('request').value)));
                //   discountStockDetails.get('transfer').setValue(((Math.abs(+discountStockDetails.get('transfer').value) + +billOfMaterialWarrantyItemFormGroup.get('transfer').value)));
                //   discountStockDetails.get('reserved').setValue(((Math.abs(+discountStockDetails.get('reserved').value) + +billOfMaterialWarrantyItemFormGroup.get('reserved').value)));
                //   discountStockDetails.get('invoice').setValue(((Math.abs(+discountStockDetails.get('invoice').value) + +billOfMaterialWarrantyItemFormGroup.get('invoice').value)));
                //   discountStockDetails.get('unitPrice').setValue((-Math.abs(Math.abs(+discountStockDetails.get('unitPrice').value) + +billOfMaterialWarrantyItemFormGroup.get('unitPrice').value)).toFixed(2));
                //   discountStockDetails.get('subTotal').setValue((-Math.abs(Math.abs(+discountStockDetails.get('subTotal').value) + +billOfMaterialWarrantyItemFormGroup.get('subTotal').value)).toFixed(2));
                //   discountStockDetails.get('vATAmount').setValue((-Math.abs(Math.abs(+discountStockDetails.get('vATAmount').value) + +billOfMaterialWarrantyItemFormGroup.get('vATAmount').value)).toFixed(2));
                //   discountStockDetails.get('totalAmount').setValue((-Math.abs(Math.abs(+discountStockDetails.get('totalAmount').value) + +billOfMaterialWarrantyItemFormGroup.get('totalAmount').value)).toFixed(2));
                //   // setting values for final row ie. BOM Invoice
                //   this.billOfMaterialForm.get('bomInvoice.subTotal').setValue((this.billOfMaterialForm.get('bomInvoice.subTotal').value - billOfMaterialWarrantyItemFormGroup.get('subTotal').value).toFixed(2));
                //   this.billOfMaterialForm.get('bomInvoice.vatAmount').setValue((this.billOfMaterialForm.get('bomInvoice.vatAmount').value - billOfMaterialWarrantyItemFormGroup.get('vATAmount').value).toFixed(2));
                //   this.billOfMaterialForm.get('bomInvoice.totalAmount').setValue((this.billOfMaterialForm.get('bomInvoice.totalAmount').value - billOfMaterialWarrantyItemFormGroup.get('totalAmount').value).toFixed(2));
                // }
                this.sortStockCodes(billOfMaterialItemFormGroup);
                this.resetStockDescForm();
              }
            });
          } else {
            this.sortStockCodes(billOfMaterialItemFormGroup);
            this.resetStockDescForm();
          }
        }
      }
    });
  }

  openPrCallDialogWithReqId(el, stockQty) {
    this.crudService.get(
      ModulesBasedApiSuffix.TECHNICIAN,
      TechnicalMgntModuleApiSuffixModels.PR_CALL,
      null, null, prepareRequiredHttpParams({ serviceCallRequestId: this.billOfMaterialModel.serviceCallRequestId, callInitiationId: this.billOfMaterialModel.callInitiationId })
    ).subscribe((response: IApplicationResponse) => {
      if (response?.isSuccess && response?.statusCode == 200) {
        let equipments = null
        if (response.resources)
          equipments = response.resources.equipments;
        if (equipments && equipments.length > 0) {
          let equipmentsArr = equipments.filter(x => x?.itemId == el?.get('itemId').value);
          if (equipmentsArr && equipmentsArr.length > 0) {
            this.snackbarService.openSnackbar('Stock Code is already added Try adding other Stock Code');
            this.rxjsService.setGlobalLoaderProperty(false);
            return;
          } else {
            let data = {
              stockType: this.stockCodeDescriptionForm?.get('stockType')?.value,
              billOfMaterialModel: this.billOfMaterialModel,
              standardTax: this.standardTax,
              userId: this.userData?.userId,
              newData: {
                itemId: el?.get('itemId').value,
                stockCode: el?.get('itemCode').value,
                stockDesc: el?.get('itemName').value,
                stockQty: stockQty,
                stockUnitPriceExVat: el?.get('unitPrice').value,
                subTotalExclVat: el?.get('subTotal').value,
                subTotalInclVat: el?.get('totalAmount').value,
                itemPricingConfigId: el?.get('itemPricingConfigId').value
              },
              resources: response?.resources,
            }
            this.openPRCallDynamicDialog(data);
          }
        } else {
          let data = {
            stockType: this.stockCodeDescriptionForm?.get('stockType')?.value,
            billOfMaterialModel: this.billOfMaterialModel,
            standardTax: this.standardTax,
            userId: this.userData?.userId,
            newData: {
              itemId: el?.get('itemId').value,
              stockCode: el?.get('itemCode').value,
              stockDesc: el?.get('itemName').value,
              stockQty: stockQty,
              stockUnitPriceExVat: el?.get('unitPrice').value,
              subTotalExclVat: el?.get('subTotal').value,
              subTotalInclVat: el?.get('totalAmount').value,
              itemPricingConfigId: el?.get('itemPricingConfigId').value
            },
            response: response?.resources,
          }
          this.openPRCallDynamicDialog(data);
        }
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  openPRCallDynamicDialog(data) {
    const ref = this.dialog.open(PrCallDoaRequestDialogComponent, {
      width: data?.isEscalate ? '1050px' : '450px',
      disableClose: true,
      data: { ...data, header: `DOA Request`, },
    });
    ref.afterClosed().subscribe((res) => {
      if (typeof res == 'object' && !res?.isEscalate) {
        res.isEscalate = true;
        this.rxjsService.setGlobalLoaderProperty(true);
        setTimeout(() => {
          this.rxjsService.setGlobalLoaderProperty(false);
          this.openPRCallDynamicDialog(res);
        }, 500);
      } else if (res) {
        this.alertDialog = true
        this.alertMsg = res;
        this.updateBillOfMaterial();
      }
    });
  }

  resetStockDescForm() {
    this.clearFormArray(this.stockAddItemFormarry);
    this.stockCodeDescriptionForm.reset('', { emitEvent: false });
    this.stockCodeDescriptionForm.get('stockType').reset('', { emitEvent: false });
    this.billOfMaterialForm.get('isStock').setValue(false, { emitEvent: false });
    this.billOfMaterialForm.get('isDiscount').setValue(false, { emitEvent: false });
    this.stockCodeDescriptionForm.markAsTouched();
  }

  openNKADoaRequestDialog(data) {
    const reqNumber = data?.response?.nkaPurchaseOrderRequestNumber ? data?.response?.nkaPurchaseOrderRequestNumber : ''
    const ref = this.dialog.open(NkaDoaRequestDialogComponent, {
      width: data?.isEscalate ? '1050px' : '450px',
      disableClose: true,
      data: { ...data, header: `NKA Purchase Order Request ${reqNumber}`, },
    });
    ref.afterClosed().subscribe((res) => {
      if (typeof res == 'object') {
        res.isEscalate = true;
        this.rxjsService.setGlobalLoaderProperty(true);
        setTimeout(() => {
          this.rxjsService.setGlobalLoaderProperty(false);
          this.openNKADoaRequestDialog(res);
        }, 500);
      } else if (res) {
        this.updateBillOfMaterial();
      }
    });
  }

  getDiscountValueItems(itemId) {
    let findItem = [];
    this.billOfMaterialModel?.technicianDiscountItems?.forEach(el => {
      if (itemId == el) {
        findItem.push(true);
      }
    });
    return findItem?.length ? true : false;
  }

  enableUnitPrice(control) {
    if (this.billOfMaterialModel?.lightningDiscountItemId == control.get('itemId').value) {
      return false;
    } else if (this.getDiscountValueItems(control?.get('itemId')?.value) && this.billOfMaterialModel?.technicianDiscountItemId == control.get('itemId').value && !this.billOfMaterialModel?.technicialCallDiscountRequestId && !this.billOfMaterialModel?.technicialCallDiscountRequestStatus) {
      return false;
    } else if (this.getDiscountValueItems(control?.get('itemId')?.value) && this.billOfMaterialModel?.technicianDiscountItemId != control.get('itemId').value) {
      return false;
    }
    return true;
  }

  onFocusUnitPrice(i: number) {
    if (!this.enableUnitPrice(this.billOfMaterialItemsFormArray?.controls[i])) {
      const unitPrice = Math.abs(this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.controls[i].get('unitPrice').value));
      this.billOfMaterialItemsFormArray?.controls[i].get('unitPrice').setValue(unitPrice);
    }
  }

  onBlurUnitPrice(i: number, control) {
    if (!this.enableUnitPrice(control)) {
      const negaNum = this.billOfMaterialItemsFormArray?.controls[i].get('unitPrice').value < 0 ? this.billOfMaterialItemsFormArray?.controls[i].get('unitPrice').value :
        control?.get('stockType')?.value == 'M' ? -Math.abs(this.billOfMaterialItemsFormArray?.controls[i].get('unitPrice').value) : this.billOfMaterialItemsFormArray?.controls[i].get('unitPrice').value;
      if (negaNum?.toString()) {
        const unitPrice = this.otherService.transformDecimal(negaNum);
        const totalAmount = this.billOfMaterialItemsFormArray?.controls[i].get('totalAmount').value ? this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.controls[i].get('totalAmount').value) : 0;
        const lightningAmt = this.getLightningAmt();
        if (lightningAmt < Math.abs(totalAmount) && this.billOfMaterialModel['lightningDiscountItemId'] == this.billOfMaterialItemsFormArray?.controls[i]?.get('itemId').value) {
          return this.onValidateLightnCoverMsg();
        }
        this.billOfMaterialItemsFormArray?.controls[i].get('unitPrice').setValue(unitPrice);
      }
    }
  }

  onKeyUpReserved(i, control) {
    if (!this.onNotSerialized(control, i) && control?.get('reserved').value && control?.get('reserved').value != 0) {
      this.rxjsService.setGlobalLoaderProperty(true);
      this.crudService.get(ModulesBasedApiSuffix.TECHNICIAN, TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_VADATE_NOTSERIALIZED, null, false,
        prepareRequiredHttpParams({
          userId: this.billOfMaterialModel['technicianId'], itemId: this.billOfMaterialItemsFormArray?.controls[i]?.get('itemId').value, callInitiationId: this.callInitiationId,
          qty: this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved').value, districtId: this.billOfMaterialModel?.districtId ? this.billOfMaterialModel?.districtId : null
        }))
        .subscribe((res: IApplicationResponse) => {
          if (res?.isSuccess && res?.statusCode == 200 && res?.resources?.isSuccess) {
            if (+this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved').value == 0) {
              this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved')?.setErrors(null, { emitEvent: false });
              this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved').setValue(0, { emitEvent: false });
              this.billOfMaterialItemsFormArray?.controls[i]?.get('request').setValue(this.billOfMaterialModel?.bomQuotationItems[i]?.request, { emitEvent: false });
              this.billOfMaterialItemsFormArray?.controls[i]?.get('transfer').setValue(this.billOfMaterialModel?.bomQuotationItems[i]?.transfer, { emitEvent: false });
            } else if (+this.billOfMaterialItemsFormArray?.controls[i]?.get('request').value == 0 && +this.billOfMaterialItemsFormArray?.controls[i]?.get('transfer').value == 0 && !this.billOfMaterialModel?.bomQuotationItems[i]?.reserved) {
              if (+this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved').value <= (+this.billOfMaterialModel?.bomQuotationItems[i]?.request + +this.billOfMaterialModel?.bomQuotationItems[i]?.transfer)) {
                let reservedTot = +this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved').value;
                let requestTot = +this.billOfMaterialModel?.bomQuotationItems[i]?.request;
                let transferTot = +this.billOfMaterialModel?.bomQuotationItems[i]?.transfer;
                if (transferTot) {
                  if (transferTot >= reservedTot) {
                    transferTot -= reservedTot;
                  } else {
                    reservedTot -= transferTot;
                    transferTot = 0;
                  }
                  this.billOfMaterialItemsFormArray?.controls[i]?.get('transfer').setValue(transferTot);
                }
                if (requestTot) {
                  if (requestTot >= reservedTot) {
                    requestTot -= reservedTot;
                  } else {
                    reservedTot -= requestTot;
                    requestTot = 0;
                  }
                  this.billOfMaterialItemsFormArray?.controls[i]?.get('request').setValue(requestTot);
                }
              } else {
                this.snackbarService.openSnackbar("Requested quantity has met not allowed add more items");
                this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved')?.setErrors({ invalid: true }, { emitEvent: false });
                this.rxjsService.setGlobalLoaderProperty(false);
              }
            } else if (+this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved').value != 0) {
              let reservedTot = +this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved').value;
              let requestTot = +this.billOfMaterialModel?.bomQuotationItems[i]?.request;
              let transferTot = +this.billOfMaterialModel?.bomQuotationItems[i]?.transfer;
              let reservedOldTot = +this.billOfMaterialModel?.bomQuotationItems[i]?.reserved;
              const totalQty = requestTot + transferTot + reservedOldTot;
              if (reservedTot > (requestTot + transferTot + reservedOldTot)) {
                this.snackbarService.openSnackbar("Requested quantity has met not allowed add more items");
                this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved')?.setErrors({ invalid: true }, { emitEvent: false });
                this.rxjsService.setGlobalLoaderProperty(false);
                return;
              }
              if (reservedOldTot == reservedTot) {
                this.billOfMaterialItemsFormArray?.controls[i]?.get('request').setValue(requestTot);
                this.billOfMaterialItemsFormArray?.controls[i]?.get('transfer').setValue(transferTot);
                this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved').setValue(reservedTot);
              } else {
                if (totalQty == reservedTot) {
                  this.billOfMaterialItemsFormArray?.controls[i]?.get('request').setValue(0);
                  this.billOfMaterialItemsFormArray?.controls[i]?.get('transfer').setValue(0);
                } else if (totalQty < reservedTot) {
                  let newTransTotal = 0;
                  let newReqTotal = 0;
                  if (transferTot != 0) {
                    newTransTotal = totalQty - reservedTot;
                    if (newTransTotal == transferTot) {
                      this.billOfMaterialItemsFormArray?.controls[i]?.get('transfer').setValue(transferTot);
                    } else if (newTransTotal > transferTot) {
                      newTransTotal -= requestTot;
                      this.billOfMaterialItemsFormArray?.controls[i]?.get('transfer').setValue(newTransTotal);
                      this.billOfMaterialItemsFormArray?.controls[i]?.get('request').setValue(requestTot);
                    }
                  }
                  if (transferTot == 0 && requestTot != 0) {
                    newReqTotal = totalQty - requestTot;
                    this.billOfMaterialItemsFormArray?.controls[i]?.get('transfer').setValue(0);
                    this.billOfMaterialItemsFormArray?.controls[i]?.get('request').setValue(newReqTotal);
                  }
                } else if (totalQty > reservedTot) {
                  let newTransTotal = 0;
                  let newReqTotal = 0;
                  if (transferTot != 0) {
                    newTransTotal = totalQty - reservedTot;
                    if (newTransTotal == transferTot) {
                      this.billOfMaterialItemsFormArray?.controls[i]?.get('transfer').setValue(transferTot);
                    } else if (newTransTotal > transferTot) {
                      newTransTotal -= requestTot;
                      this.billOfMaterialItemsFormArray?.controls[i]?.get('transfer').setValue(newTransTotal);
                      this.billOfMaterialItemsFormArray?.controls[i]?.get('request').setValue(requestTot);
                    } else if (newTransTotal < transferTot) {
                      newTransTotal -= requestTot;
                      this.billOfMaterialItemsFormArray?.controls[i]?.get('transfer').setValue(newTransTotal);
                    }
                  }
                  if (transferTot == 0 && requestTot != 0) {
                    newReqTotal = totalQty - reservedTot;
                    this.billOfMaterialItemsFormArray?.controls[i]?.get('transfer').setValue(0);
                    this.billOfMaterialItemsFormArray?.controls[i]?.get('request').setValue(newReqTotal);
                  }
                }
              }
            }
            this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved')?.updateValueAndValidity({ emitEvent: false });
            this.billOfMaterialItemsFormArray?.controls[i]?.get('subTotal')?.setValue(this.otherService.transformDecimal(res?.resources?.subTotal));
            this.billOfMaterialItemsFormArray?.controls[i]?.get('vATAmount')?.setValue(this.otherService.transformDecimal(res?.resources?.vatAmount));
            this.billOfMaterialItemsFormArray?.controls[i]?.get('totalAmount')?.setValue(this.otherService.transformDecimal(res?.resources?.totalAmount));
            this.onCalculateFinalTotal();
            this.onDiscountWarrantyReservedValueChange(i);
          } else if (!res?.resources?.isSuccess) {
            if (res?.resources?.validateMessage) {
              this.snackbarService.openSnackbar(res?.resources?.validateMessage);
            }
            this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved').setValue(this.billOfMaterialModel?.bomQuotationItems[i]?.reserved);
            this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved')?.setErrors(null, { emitEvent: false });
            this.billOfMaterialItemsFormArray?.controls[i]?.get('request').setValue(this.billOfMaterialModel?.bomQuotationItems[i]?.request, { emitEvent: false });
            this.billOfMaterialItemsFormArray?.controls[i]?.get('transfer').setValue(this.billOfMaterialModel?.bomQuotationItems[i]?.transfer, { emitEvent: false });
          }
          this.rxjsService.setGlobalLoaderProperty(false);
        })
    } else if (!this.onNotSerialized(control, i) && control?.get('reserved').value == 0) {
      setTimeout(() => {
        if (!this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved').value || this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved').value == 0) {
          this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved').setValue(0, { emitEvent: false });
          if (this.callType == '1') {
            this.billOfMaterialItemsFormArray?.controls[i]?.get('transfer').setValue(this.billOfMaterialModel?.bomQuotationItems[i]?.transfer + this.billOfMaterialModel?.bomQuotationItems[i]?.reserved, { emitEvent: false });
          } else {
            this.billOfMaterialItemsFormArray?.controls[i]?.get('request').setValue(this.billOfMaterialModel?.bomQuotationItems[i]?.request + this.billOfMaterialModel?.bomQuotationItems[i]?.reserved, { emitEvent: false });
          }
          if (this.billOfMaterialItemsFormArray?.controls[i].get('WarrantyQty').value > this.billOfMaterialItemsFormArray?.controls[i]?.get('reserved').value) {
            this.onDecrementDiscountWarranty(i);
          }
        }
      }, 2000)
    }
  }

  onDiscountWarrantyReservedValueChange(i) {
    this.crudService.get(
      ModulesBasedApiSuffix.TECHNICIAN,
      TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_WARRANTY_CHECK,
      undefined,
      false,
      prepareGetRequestHttpParams('', '', {
        CallInitiationId: this.callInitiationId,
        ItemId: this.billOfMaterialItemsFormArray?.controls[i].get('itemId').value,
        StockTypeId: this.billOfMaterialItemsFormArray?.controls[i].get('stockTypeId').value
      })
    ).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess == true && response.statusCode == 200 && !response?.message) {
        const discountStockIndex = this.billOfMaterialItemsFormArray.controls.findIndex(element => element.get('itemId').value.toLowerCase() == response.resources['itemId'].toLowerCase());
        const previousWarrantyQty = this.billOfMaterialItemsFormArray?.controls[i].get('WarrantyQty').value;
        if (response.resources['isWarranty'] || response.resources['isDiscountMaintenance']) {
          this.billOfMaterialItemsFormArray?.controls[i].get('IsWarranty').setValue(true);
          if (this.billOfMaterialItemsFormArray?.controls[i].get('reserved').value > response?.resources?.warrantyQty) {
            this.billOfMaterialItemsFormArray?.controls[i].get('WarrantyQty').setValue(response?.resources?.warrantyQty);
          } else {
            this.billOfMaterialItemsFormArray?.controls[i].get('WarrantyQty').setValue(this.billOfMaterialItemsFormArray?.controls[i].get('reserved').value);
          }
          this.warrantyMaintenanceDetail.push(this.billOfMaterialItemsFormArray?.controls[i]);
        }
        if (discountStockIndex == -1 && (response.resources['isWarranty'] || response.resources['isDiscountMaintenance'])) {
          let serialNumberlWarrantyItemFormGroup = this.createFormGroupToAddInGrid();
          serialNumberlWarrantyItemFormGroup.get('stockTypeId')?.setValue(response.resources['stockTypeId']);
          serialNumberlWarrantyItemFormGroup.get('stockType')?.setValue(response.resources['stockType']);
          serialNumberlWarrantyItemFormGroup.get('itemId')?.setValue(response.resources['itemId']);
          serialNumberlWarrantyItemFormGroup.get('itemCode')?.setValue(response.resources['itemCode']);
          serialNumberlWarrantyItemFormGroup.get('itemName')?.setValue(response.resources['itemName']);

          const result = calculateBOMPrice({
            qty: this.billOfMaterialItemsFormArray?.controls[i].get('WarrantyQty')?.value,
            price: this.billOfMaterialItemsFormArray.controls[i].get('unitPrice')?.value,
            taxPercent: this.standardTax, roundFn: toRoundOffWithMathRound
          });
          serialNumberlWarrantyItemFormGroup.get('unitPrice')?.setValue(-Math.abs(result?.subTotal));
          serialNumberlWarrantyItemFormGroup.get('subTotal')?.setValue(-Math.abs(result?.subTotal));
          serialNumberlWarrantyItemFormGroup.get('vATAmount')?.setValue(-Math.abs(result?.vatAmount));
          serialNumberlWarrantyItemFormGroup.get('totalAmount')?.setValue(-Math.abs(result?.totalAmount));
          serialNumberlWarrantyItemFormGroup.get('WarrantyQty')?.setValue(+this.billOfMaterialItemsFormArray?.controls[i].get('WarrantyQty')?.value);
          this.sortStockCodes(serialNumberlWarrantyItemFormGroup);
        } else if (discountStockIndex != -1 && (response.resources['isWarranty'] || response.resources['isDiscountMaintenance'])) {
          // Related to Discount Warrenties other than 1st time
          const currentWarrantyQty = this.billOfMaterialItemsFormArray?.controls[i].get('WarrantyQty')?.value;
          if (previousWarrantyQty == currentWarrantyQty) {
            return;
          } else if (previousWarrantyQty > currentWarrantyQty) {
            const WarrantyQtyDiff = +previousWarrantyQty - +currentWarrantyQty;
            this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('WarrantyQty')?.setValue(+this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('WarrantyQty')?.value - +WarrantyQtyDiff);
            const decreaseUnitPrice = calculateSubTotalBOMPrice({
              qty: WarrantyQtyDiff, price: this.billOfMaterialItemsFormArray.controls[i].get('unitPrice')?.value, taxPercent: this.standardTax,
              roundFn: toRoundOffWithMathRound
            });
            this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('unitPrice')?.setValue((-Math.abs(toRoundOffWithMathRound(this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('unitPrice')?.value) + +decreaseUnitPrice))));
          } else if (previousWarrantyQty < currentWarrantyQty) {
            const WarrantyQtyDiff = +currentWarrantyQty - +previousWarrantyQty;
            this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('WarrantyQty')?.setValue(+this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('WarrantyQty')?.value + +WarrantyQtyDiff);
            const increaseUnitPrice = calculateSubTotalBOMPrice({
              qty: WarrantyQtyDiff, price: this.billOfMaterialItemsFormArray.controls[i].get('unitPrice')?.value, taxPercent: this.standardTax,
              roundFn: toRoundOffWithMathRound
            });
            this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('unitPrice')?.setValue((-Math.abs(toRoundOffWithMathRound(this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('unitPrice')?.value) - +increaseUnitPrice))));
          }
          this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('subTotal')?.setValue((-Math.abs(this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('unitPrice')?.value))));
          const subTotal = this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray.controls[discountStockIndex].get('subTotal')?.value);
          const result = calculateVatTotalBOMPrice({
            roundedSubTotal: subTotal, taxPercent: this.standardTax,
            roundFn: toRoundOffWithMathRound
          });
          this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('vATAmount')?.setValue((-Math.abs(this.otherService.transformCurrToNum(result?.vatAmount))));
          this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('totalAmount')?.setValue((-Math.abs(this.otherService.transformCurrToNum(result?.totalAmount))));
        }
        this.onCalculateFinalTotal();
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  onDecrementDiscountWarranty(i) {
    this.crudService.get(
      ModulesBasedApiSuffix.TECHNICIAN,
      TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_WARRANTY_CHECK,
      undefined,
      false,
      prepareGetRequestHttpParams('', '', {
        CallInitiationId: this.callInitiationId,
        ItemId: this.billOfMaterialItemsFormArray?.controls[i].get('itemId').value,
        StockTypeId: this.billOfMaterialItemsFormArray?.controls[i].get('stockTypeId').value
      })
    ).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess == true && response.statusCode == 200 && !response?.message) {
        let discountStockIndex = this.billOfMaterialItemsFormArray.controls.findIndex(element => element.get('itemId').value.toLowerCase() == response.resources['itemId'].toLowerCase());
        if (discountStockIndex != -1 && (response.resources['isWarranty'] || response.resources['isDiscountMaintenance'])) {
          // Related to Discount Warrenties other than 1st time
          this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('WarrantyQty').setValue(+this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('WarrantyQty').value - this.billOfMaterialItemsFormArray?.controls[i].get('WarrantyQty').value);
          const unitPriceDecrease = calculateSubTotalBOMPrice({
            qty: this.billOfMaterialItemsFormArray?.controls[i].get('WarrantyQty').value, price: this.billOfMaterialItemsFormArray.controls[i].get('unitPrice').value,
            taxPercent: this.standardTax, roundFn: toRoundOffWithMathRound
          })
          this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('unitPrice').setValue((-Math.abs(Math.abs(+this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('unitPrice').value) - +unitPriceDecrease)));
          this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('subTotal').setValue((-Math.abs(Math.abs(+this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('unitPrice').value))));
          const result = calculateVatTotalBOMPrice({
            roundedSubTotal: this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('subTotal').value,
            taxPercent: this.standardTax, roundFn: toRoundOffWithMathRound
          })
          this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('vATAmount').setValue(result?.vatAmount);
          this.billOfMaterialItemsFormArray?.controls[discountStockIndex].get('totalAmount').setValue(result?.totalAmount);
          this.billOfMaterialItemsFormArray?.controls[i].get('WarrantyQty').setValue(0);
        }
        this.onCalculateFinalTotal();
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  onKeyUpUnitPrice(i, control) {
    clearTimeout(this.discountTimer);
    this.discountTimer = setTimeout(() => {
      if (this.billOfMaterialItemsFormArray?.controls[i].get('unitPrice').value == '-') {
        return;
      }
      const unitPrice: any = this.billOfMaterialItemsFormArray?.controls[i].get('unitPrice').value ? this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.controls[i].get('unitPrice').value) : '';
      if (typeof unitPrice != 'number' && unitPrice) {
        return;
      } if (!unitPrice) {
        this.billOfMaterialItemsFormArray?.controls[i].get('unitPrice').setValidators([Validators.required, Validators.min(0)]);
        this.billOfMaterialItemsFormArray?.controls[i].get('unitPrice').updateValueAndValidity();
      }
      this.onCalculateUnitPriceChange(i, unitPrice);
      const totalAmountIncVat: any = this.billOfMaterialItemsFormArray?.controls[i].get('totalAmount').value ? this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.controls[i].get('totalAmount').value) : 0;
      const lightningAmt = this.getLightningAmt();
      if (this.billOfMaterialModel['lightningDiscountItemId'] == control?.get('itemId').value) {
        if (lightningAmt < Math.abs(totalAmountIncVat)) { //lightning cover
          return this.onValidateLightnCoverMsg();
        }
      } else if (this.getDiscountValueItems(control?.get('itemId').value) && this.billOfMaterialModel['technicianDiscountItemId'] == control?.get('itemId').value) {
        this.onCalculateDiscountTechItem(i, control?.get('itemId').value, totalAmountIncVat);
      } else if (this.getDiscountValueItems(control?.get('itemId').value) && this.billOfMaterialModel['technicianDiscountItemId'] != control?.get('itemId').value) {
        const totalAmountForPositiveIncVat = this.onCaluateDiscountTotal(control?.get('itemId').value);
        const totalAmt = Math.abs(this.otherService.transformCurrToNum(this.billOfMaterialForm?.get('bomInvoice.totalAmount')?.value));
        if (totalAmountForPositiveIncVat < Math.abs(totalAmountIncVat) && totalAmt > 0.05) { //discount items
          this.billOfMaterialItemsFormArray?.controls[i].get('unitPrice')?.setValue(0);
          this.onCalculateUnitPriceChange(i, 0);
          return this.onValidateDiscountCoverMsg(control?.get('itemId').value);
        }
      }
    }, 1200);
  }

  onCalculateDiscountTechItem(i: number, itemId: string, totalAmountIncVat: number,) {
    const totalAmountForPositiveIncVat = this.onCaluateDiscountTotal(itemId);
    const discount: any = (Math.abs(totalAmountIncVat) * 100) / totalAmountForPositiveIncVat;
    const totalAmt = Math.abs(this.otherService.transformCurrToNum(this.billOfMaterialForm?.get('bomInvoice.totalAmount')?.value));
    if (totalAmountForPositiveIncVat < Math.abs(totalAmountIncVat) && totalAmt > 0.05) { //discount items
      this.billOfMaterialItemsFormArray?.controls[i].get('unitPrice')?.setValue(0);
      return this.onValidateDiscountCoverMsg(this.billOfMaterialModel.technicianDiscountItemId);
    } else if (Math.abs(toRoundOffWithMathRound(discount)) > +this.billOfMaterialModel?.technicalDiscountPercentage) {
      this.openServiceDiscountDialog(i);
    }
  }

  onCalculateUnitPriceChange(i: number, unitPrice: number) {
    let totalRequestQty = 0
    const used = +this.billOfMaterialItemsFormArray?.controls[i].get('used').value;
    const request = +this.billOfMaterialItemsFormArray?.controls[i].get('request').value;
    const transfer = +this.billOfMaterialItemsFormArray?.controls[i].get('transfer').value;
    const reserved = +this.billOfMaterialItemsFormArray?.controls[i].get('reserved').value;
    const invoice = +this.billOfMaterialItemsFormArray?.controls[i].get('invoice').value;
    totalRequestQty = used + request + transfer + reserved + invoice;
    const result = calculateBOMPrice({
      qty: totalRequestQty, price: unitPrice,
      taxPercent: this.standardTax, roundFn: toRoundOffWithMathRound
    });
    this.billOfMaterialItemsFormArray?.controls[i].get('subTotal').setValue(this.otherService.transformDecimal((-Math.abs(+result?.subTotal))));
    this.billOfMaterialItemsFormArray?.controls[i].get('vATAmount').setValue(this.otherService.transformDecimal(-Math.abs(+result?.vatAmount)));
    this.billOfMaterialItemsFormArray?.controls[i].get('totalAmount').setValue(this.otherService.transformDecimal(-Math.abs(+result?.totalAmount)));
    this.onCalculateFinalTotal();
  }

  onCalculateFinalTotal() {
    let bomsubTotal = 0;
    let bomvATAmount = 0;
    let bomtotalAmount = 0;
    this.billOfMaterialItemsFormArray?.getRawValue()?.forEach(el => {
      if (el?.IsDeleted == false) {
        bomsubTotal += this.otherService.transformCurrToNum(el?.subTotal);
        bomvATAmount += this.otherService.transformCurrToNum(el?.vATAmount);
        bomtotalAmount += this.otherService.transformCurrToNum(el?.totalAmount);
      }
    })
    this.billOfMaterialForm.get('bomInvoice.subTotal').setValue(this.otherService.transformDecimal(bomsubTotal));
    this.billOfMaterialForm.get('bomInvoice.vatAmount').setValue(this.otherService.transformDecimal(bomvATAmount));
    this.billOfMaterialForm.get('bomInvoice.totalAmount').setValue(this.otherService.transformDecimal(bomtotalAmount));
  }

  onCalculateLightningTotal() {
    let bomtotalAmount = 0;
    this.billOfMaterialItemsFormArray?.getRawValue()?.forEach(el => {
      if (this.billOfMaterialModel?.lightningDiscountItemId != el?.itemId && el?.IsDeleted == false) {
        bomtotalAmount += this.otherService.transformCurrToNum(el?.totalAmount);
      }
    })
    return toRoundOffWithMathRound(bomtotalAmount);
  }

  onCaluateDiscountTotal(itemId) {
    let bomtotalAmount = 0;
    this.billOfMaterialItemsFormArray?.getRawValue()?.forEach(el => {
      if (el?.itemId != itemId && el?.IsDeleted == false) {
        bomtotalAmount += this.otherService.transformCurrToNum(el?.totalAmount);
      }
    });
    return toRoundOffWithMathRound(bomtotalAmount);
  }

  onCaluateWithDiscountTotal() {
    let bomtotalAmount = 0;
    this.billOfMaterialItemsFormArray?.getRawValue()?.forEach(el => {
      if (this.billOfMaterialModel['technicianDiscountItems']?.indexOf(el?.itemId) != -1 && el?.IsDeleted == false) {
        bomtotalAmount += this.otherService.transformCurrToNum(el?.totalAmount);
      }
    });
    return toRoundOffWithMathRound(bomtotalAmount);
  }

  onCaluateWithoutDiscountTotal() {
    let bomtotalAmount = 0;
    this.billOfMaterialItemsFormArray?.getRawValue()?.forEach(el => {
      if (this.billOfMaterialModel['technicianDiscountItems']?.indexOf(el?.itemId) == -1 && el?.IsDeleted == false) {
        bomtotalAmount += this.otherService.transformCurrToNum(el?.totalAmount);
      }
    });
    return toRoundOffWithMathRound(bomtotalAmount);
  }

  openServiceDiscountDialog(i: number) {
    const dialogReff = this.dialog.open(ServiceForDiscountModalComponent, {
      width: '450px',
      data: {
        header: 'Service Call Discount Approval Request',
        createdUserId: this.userData?.userId,
        index: i,
        itemId: this.billOfMaterialItemsFormArray?.controls[i].get('itemId')?.value,
        BillofMaterialId: this.billOfMaterialModel['billOfMaterialId'],
        DiscountAmountExVat: Math.abs(this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.controls[i].get('subTotal').value)),
        DiscountAmountInVat: Math.abs(this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.controls[i].get('totalAmount').value)),
        technicialCallDiscountRequestId: this.billOfMaterialModel['technicialCallDiscountRequestId']
      },
      disableClose: true
    });
    dialogReff.afterClosed().subscribe(result => {
      if (result?.technicialCallDiscountRequestId) {
        this.billOfMaterialModel.technicialCallDiscountRequestId = result?.technicialCallDiscountRequestId;
        this.updateBillOfMaterial();
      } else {
        return this.onValidateDoaApprovalMsg();
      };
    });
  }

  getGoodsReturnDetails(StockOrderNumber) {
    this.crudService.get(ModulesBasedApiSuffix.INVENTORY,
      TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_GOODS_RETURN_DETAILS,
      undefined,
      false,
      prepareRequiredHttpParams({
        StockOrderNumber: StockOrderNumber
      })).subscribe(response => {
        this.rxjsService.setGlobalLoaderProperty(false);
        if (response?.isSuccess == true && response?.statusCode == 200) {
          if (response?.resources?.hasOwnProperty('goodsReturnsItems') && response?.resources?.goodsReturnsItems?.length > 0) {
            this.goodsReturnData = response?.resources?.goodsReturnsItems;
          }
        }
      });
  }

  createBillOfMaterialForm(billOfMaterialModel?: BillOfMaterialModel) {
    let materialModel = new BillOfMaterialModel(billOfMaterialModel);
    this.billOfMaterialForm = this.formBuilder.group({});
    let billOfMaterialItemDetails = this.formBuilder.array([]);
    Object.keys(materialModel).forEach((key) => {
      if (typeof materialModel[key] !== 'object') {
        this.billOfMaterialForm.addControl(key, new FormControl(materialModel[key]));
      } else {
        if (key == 'bomInvoice') {
          let bomInvoice = this.formBuilder.group({
            'exclVAT': '',
            'subTotal': '',
            'totalAmount': '',
            'vatAmount': ''
          });
          this.billOfMaterialForm.addControl(key, bomInvoice);
        } else if (key == 'billOfMaterialItems') {
          this.billOfMaterialForm.addControl(key, billOfMaterialItemDetails);
        }
      }
    });

    this.billOfMaterialForm = setRequiredValidator(this.billOfMaterialForm, ['billOfMaterialItems']);
    this.billOfMaterialForm.get('stockCodeSerialNumber').setValidators([Validators.minLength(1)]);
    this.billOfMaterialForm.get('stockCodeSerialNumber').updateValueAndValidity();
  }

  createStockCodeDescriptionForm(stockCodeDescriptionModel?: StockCodeDescriptionModel) {
    let stockModel = new StockCodeDescriptionModel(stockCodeDescriptionModel);
    this.stockCodeDescriptionForm = this.formBuilder.group({});
    Object.keys(stockModel).forEach((key) => {
      if (typeof stockModel[key] !== 'object') {
        this.stockCodeDescriptionForm.addControl(key, new FormControl({
          value: stockModel[key],
          disabled: (key.toLowerCase() == 'stockUnitPriceExcl' || key.toLowerCase() == 'stockRequestedQty') ? true : false
        }));
      } else {
        this.stockCodeDescriptionForm.addControl(key, new FormArray([]));
      }
    });
    this.stockCodeDescriptionForm = setRequiredValidator(this.stockCodeDescriptionForm, ['stockType', 'stockCode', 'stockDescription']);
    this.stockCodeDescriptionForm.get('stockUnitPriceExcl').disable();
    this.stockCodeDescriptionForm.get('stockRequestedQty').disable();
  }

  getBillOfMaterialData() {
    this.warrantyMaintenanceDetail = [];
    this.serialNumberError = false;
    let obj = {
      CustomerId: this.customerId,
      CallInitiationId: this.callInitiationId
    };
    if (this.quotationVersionId) {
      obj['QuotationVersionId'] = this.quotationVersionId;
    }
    let api = [this.crudService.get(ModulesBasedApiSuffix.TECHNICIAN, TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_DETAILS,
      undefined, false, prepareRequiredHttpParams(obj)).pipe(map(result => result), catchError(error => of(error))),
    this.crudService.get(ModulesBasedApiSuffix.IT_MANAGEMENT, TechnicalMgntModuleApiSuffixModels.STANDARD_TAX).pipe(map(result => result), catchError(error => of(error))),
    ]
    forkJoin(api).pipe(map((res: IApplicationResponse[]) => {
      res?.forEach((response: IApplicationResponse, ix: number) => {
        if (response?.isSuccess == true && response?.statusCode == 200 && response?.resources) {
          switch (ix) {
            case 0:
              response?.resources?.bomQuotationItems?.forEach(val => {
                if (response?.resources?.lightningDiscountItemId == val?.itemId) {
                  val.unitPrice = this.otherService.transformDecimal(val.unitPrice);
                }
                return val;
              })
              break;
          }
        }
      })
      return res;
    })).subscribe((response: IApplicationResponse[]) => {
      response?.forEach((res: IApplicationResponse, ix: number) => {
        if (res.isSuccess == true && res.statusCode == 200 && res?.resources) {
          switch (ix) {
            case 0:
              this.billOfMaterialModel = res?.resources;
              this.onPatchValue();
              if (this.billOfMaterialModel?.status?.toLowerCase() == 'invoiced' && this.isVoid == false) {
                this.isVoid = true;
              }
              break;
            case 1:
              this.standardTax = res?.resources?.taxPercentage;
              break;
          }
        }
      });
      this.rxjsService.setGlobalLoaderProperty(false);
      if (this.isVoid) {
        this.billOfMaterialForm.disable();
        this.billOfMaterialForm.markAsUntouched();
        this.stockCodeDescriptionForm.disable();
        this.stockCodeDescriptionForm.markAsUntouched();
      }
      if (this.billOfMaterialModel?.isInstallationOnlyCustomer && this.billOfMaterialModel?.isRadio) {
        if (this.getNotificationDialogOpened()) {
          return;
        }
        this.openConfigDialog({ title: 'Notification', message: `Unable to load radio, Installed only customer` });
        return;
      }
    });
  }

  getNotificationDialogOpened() {
    let notificationDialogAlreadyExist = [];
    this.dialog.openDialogs?.forEach((el: any) => {
      if (el?.componentInstance?.popupData?.title == 'Notification') {
        notificationDialogAlreadyExist.push(true);
      }
    })
    return notificationDialogAlreadyExist?.length;
  }

  onPatchValue() {
    if (this.billOfMaterialModel.serviceCallRequestId == null) {
      this.isEscalateSubmit = false;
    }
    else {
      this.isEscalateSubmit = true;
    }
    let billOfMaterialModel = new BillOfMaterialModel(this.billOfMaterialModel, this.userData?.userId);
    let billOfMaterialItemsFormArray = this.billOfMaterialItemsFormArray;
    billOfMaterialItemsFormArray.clear();
    billOfMaterialModel['billOfMaterialItems'].forEach(element => {
      let billOfMaterialItemFormGroup = this.formBuilder.group({
        checkBillOfMaterial: element['checkBillOfMaterial'],
        billOfMaterialItemId: element['billOfMaterialItemId'],
        billOfMaterialId: element['billOfMaterialId'],
        stockTypeId: element['stockTypeId'],
        stockType: element['stockType'],
        itemId: element['itemId'],
        itemCode: element['itemCode'],
        itemName: element['itemName'],
        invoice: element['invoice'],
        transfer: element['transfer'],
        used: element['used'],
        reserved: element['reserved'],
        request: element['request'],
        unitPrice: element['unitPrice'],
        subTotal: element['subTotal'],
        kitConfigId: element['kitConfigId'],
        kitTypeName: element['kitTypeName'],
        vATAmount: element['vATAmount'] ? element['vATAmount'] : 0,
        totalAmount: element['totalAmount'],
        createdUserId: element['createdUserId'],
        modifiedUserId: element['modifiedUserId'],
        IsDeleted: element['IsDeleted'],
        IsWarranty: element['IsWarranty'],
        WarrantyQty: element['WarrantyQty'],
        systemTypeId: element['systemTypeId'],
        itemPricingConfigId: element['itemPricingConfigId'],
        isNotSerialized: element['isNotSerialized'],
      });
      if (element['IsWarranty']) {
        this.warrantyMaintenanceDetail.push(billOfMaterialItemFormGroup);
      }
      billOfMaterialItemsFormArray.push(billOfMaterialItemFormGroup);
    });
    this.billOfMaterialForm.patchValue(billOfMaterialModel, { emitEvent: false });
    this.billOfMaterialForm.get('createdUserId').setValue(this.userData?.userId);
    this.billOfMaterialForm.get('modifiedUserId').setValue(this.userData?.userId);
    this.billOfMaterialForm.get('referenceId').setValue(this.callInitiationId);
    this.billOfMaterialForm.get('bomInvoice.totalAmount').setValue(billOfMaterialModel['bomInvoice']['totalAmount'] ? billOfMaterialModel['bomInvoice']['totalAmount'] : 0);
    this.billOfMaterialForm.get('isDiscount').setValue(false);
    this.billOfMaterialForm.get('isStock').setValue(false);
    if (this.billOfMaterialModel['stockOrderNumber'] && this.callType == '1' && !this.billOfMaterialModel?.isDealerCall) {
      this.getGoodsReturnDetails(this.billOfMaterialModel['stockOrderNumber']);
    } else {
      this.goodsReturnData = [];
    }
    this.billOfMaterialItemsFormArray.markAsUntouched();
    this.billOfMaterialItemsFormArray.markAsPristine();
    this.billOfMaterialForm.get('stockCodeSerialNumber').markAsUntouched();
    this.stockCodeDescriptionForm.get('stockType').setValue('', { emitEvent: false });
    this.stockCodeDescriptionForm.get('stockType').markAsUntouched();
    this.stockCodeDescriptionForm.get('stockRequestedQty').markAsUntouched();
    this.stockCodeDescriptionForm.get('stockCode').setValue('', { emitEvent: false });
    this.stockCodeDescriptionForm.get('stockCode').markAsUntouched();
    this.stockCodeDescriptionForm.get('stockDescription').setValue('', { emitEvent: false });
    this.stockCodeDescriptionForm.get('stockDescription').markAsUntouched();
  }

  get billOfMaterialItemsFormArray(): FormArray {
    if (this.billOfMaterialForm !== undefined) {
      return (<FormArray>this.billOfMaterialForm.get('billOfMaterialItems'));
    }
  }

  get stockAddItemFormarry(): FormArray {
    if (this.stockCodeDescriptionForm !== undefined) {
      return this.stockCodeDescriptionForm.get('stockAddItemFormarry') as FormArray;
    }
  }

  //Clear from arry
  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  };

  getBillOfMaterialLength() {
    let findArr = [];
    this.billOfMaterialItemsFormArray?.getRawValue()?.forEach(el => {
      if (el?.billOfMaterialItemId) {
        findArr.push(true);
      }
    });
    return findArr?.length;
  }

  openStockDetailsPopup() {
    const dialogRemoveStockCode = this.dialog.open(BillOfMaterialScanModalComponent, {
      width: '450px',
      data: {
        buttons: {
          cancel: 'No',
          create: 'Yes'
        }
      }, disableClose: true
    });

    dialogRemoveStockCode.afterClosed().subscribe(result => {
      if (!result) return;
      this.rxjsService.setDialogOpenProperty(false);
    });
  }

  openZonePopup() {
    if (!this.getBOMActionPermission(PermissionTypes.ADD)) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    const dialogRemoveStockCode = this.dialog.open(BillOfMaterialZoneModalComponent, {
      width: '450px',
      data: {
        message: `Are you sure you want to<br />remove the stock code: ?`,
        buttons: {
          cancel: 'No',
          create: 'Yes'
        }
      }, disableClose: true
    });

    dialogRemoveStockCode.afterClosed().subscribe(result => {
      if (!result) return;

      this.rxjsService.setDialogOpenProperty(false);
    });
  }

  navigateCustomerView() {
    this.rxjsService.setViewCustomerData({
      customerId: this.customerId,
      addressId: this.customerAddressId,
      customerTab: 3,
      monitoringTab: null,
    })
    this.rxjsService.navigateToViewCustomerPage();
  }

  navigateToPage() {
    let routerUrl = '/customer/manage-customers/call-initiation';
    if (this.billOfMaterialModel?.isDealerCall) {
      routerUrl = '/customer/manage-customers/dealer-call';
    }
    this.rxjsService.setViewCallInitiationData({
      customerId: this.customerId,
      customerAddressId: this.customerAddressId,
      partitionId: this.partitionId,
      initiationId: this.callInitiationId,
      appointmentId: this.appointmentId ? this.appointmentId : null,
      isInstallPreCheck: this.isInstallPreCheck,
      isUpselling: this.isUpselling,
      isCounterSale: this.isCounterSale,
      isFeedback: this.isFeedback,
      isNKACustomer: this.isNKACustomer,
      fromPage: this.fromPage,
      callType: this.callType
    })
    this.rxjsService.navigateToCallInitiationPage(routerUrl);
  }

  checkAll(event?) {
    let formArray = this.billOfMaterialItemsFormArray;
    if (event.checked) {
      formArray['controls'].map(element => element.get('checkBillOfMaterial').setValue(true));
    } else {
      formArray['controls'].forEach(element => {
        formArray['controls'].map(element => element.get('checkBillOfMaterial').setValue(false));
      });
    }
  }

  getCheckedItems() {
    const selectedItems = this.billOfMaterialItemsFormArray['controls'].map(element => element.get('checkBillOfMaterial').value == true);
    return selectedItems?.every(el => el == true) && this.billOfMaterialItemsFormArray?.controls?.length;
  }

  removeStockDialog() {
    if (!this.getBOMActionPermission(PermissionTypes.DELETE)) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    const formArray = this.billOfMaterialItemsFormArray;
    const ids = formArray?.controls?.filter(d => d.get('checkBillOfMaterial').value).map(d => d.get('itemId').value);
    if (this.getBillOfMaterialsRemove() || ids?.length <= 0) {
      this.snackbarService.openSnackbar("Please select the atleast one item to remove");
      return;
    }
    let messageToDisplay = '';
    if (this.selectAll.checked) {
      messageToDisplay = 'Are you sure you want to remove all items?';
    } else {
      messageToDisplay = 'Are you sure you want to remove the selected items?';
    }
    const dialogReff = this.dialog.open(BillOfMaterialValidationModalComponent, {
      width: '450px',
      data: {
        buttons: {
          cancel: 'No',
          create: 'Yes'
        },
        message: messageToDisplay,
        header: 'Remove Stock',
      },
      disableClose: true
    });
    dialogReff.afterClosed().subscribe(result => {
      if (result) {
        this.onAfterRemoveStockCode(formArray, ids);
      } else { // No
        let event = {};
        event['checked'] = false;
        this.checkAll(event);
        if (this.selectAll.checked) {
          this.selectAll.checked = false;
        }
        return;
      }
    });
  }

  onAfterRemoveStockCode(formArray, ids) {
    if (this.billOfMaterialModel['billOfMaterialId']) {
      this.crudService.get(
        ModulesBasedApiSuffix.TECHNICIAN,
        TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_REMOVE_VALIDATION,
        undefined,
        false,
        prepareGetRequestHttpParams('', '', {
          BillOfMaterialId: this.billOfMaterialModel['billOfMaterialId'],
          ItemIds: ids.join(',')
        })).subscribe(response => {
          this.rxjsService.setGlobalLoaderProperty(false);
          if (response.isSuccess == true && response.statusCode == 200) {
            if (response.resources.isSuccess) {
              this.removeStockByLoop(formArray);
            } else {
              let dialogData = {};
              let dialogWidth = '450px';
              if (response.resources?.messageType == '1') {
                dialogWidth = '500px';
                dialogData = {
                  buttons: {
                    cancel: 'Cancel',
                    create: 'Sent Stock Return Request'
                  },
                  message: response.resources?.validateMessage,
                  header: 'Remove Stock',
                };
              } else if (response.resources?.messageType == '2' || response.resources?.messageType == '3') {
                dialogWidth = '550px';
                dialogData = {
                  buttons: {
                    cancel: 'Ok'
                  },
                  message: response.resources?.validateMessage,
                  header: 'Remove Stock',
                };
              } else if (response.resources?.messageType == '4') {
                return this.snackbarService.openSnackbar(response.resources?.validateMessage);
              }
              const dialogReff = this.dialog.open(BillOfMaterialValidationModalComponent, {
                width: dialogWidth,
                data: dialogData,
                disableClose: true
              });
              dialogReff.afterClosed().subscribe(result => {
                if (result) {
                  let event = {};
                  event['checked'] = false;
                  this.checkAll(event);
                  if (this.selectAll.checked) {
                    this.selectAll.checked = false;
                  }
                  return;
                }
              });
            }
          }
        });
    } else {
      this.removeStockByLoop(formArray);
    }
  }

  // Remove selected items from GRID and pass filtered array to function onCalculateFinalTotal to calculate BOM Invoice
  removeStockByLoop(completeFormArray: FormArray) {
    let filteredArray = [];
    let findUnSavedItemId = [];
    let discountStockDetails = this.billOfMaterialItemsFormArray.controls.find(element => element.get('itemId').value.toLowerCase() == this.billOfMaterialModel?.discountWithinWarrantyItemId);
    let prCallDetails = this.billOfMaterialItemsFormArray.controls.find(element => (element.get('itemId').value == this.billOfMaterialModel['prCallDiscountItemId'] && this.billOfMaterialModel['isPRCall']) ||
      (element.get('itemId').value == this.billOfMaterialModel['saveOfferDiscountItemId'] && this.billOfMaterialModel['isSaveOffer']));
    completeFormArray.controls.forEach((tableElement, i: number) => {
      // stock code which is selected for removal will have checkBillOfMaterial >> true else >> false
      // if checkBillOfMaterial == false, then push that stock code in filteredArray for final invoice, else dont push.
      // since we are passing filtered array to calculate final invoice so it should be filtered based on call type like
      // PR call, warranty discount etc. bcoz functionalities are different while adding them in Grid
      if ((this.billOfMaterialModel['isPRCall'] || this.billOfMaterialModel['isSaveOffer'])) { // PR Call
        if (!tableElement?.get('checkBillOfMaterial').value && !tableElement?.get('IsDeleted').value) {
          filteredArray.push(tableElement);
        } else {
          if (!tableElement.get('IsDeleted').value && prCallDetails) {
            const unitPricePRDetails = Math.abs(prCallDetails?.get('unitPrice').value) - tableElement?.get('unitPrice').value;
            prCallDetails?.get('unitPrice').setValue(-Math.abs(toRoundOffWithMathRound(unitPricePRDetails)));
            const subTotalPRDetails = Math.abs(prCallDetails?.get('subTotal').value) - tableElement?.get('subTotal').value;
            prCallDetails?.get('subTotal').setValue(-Math.abs(toRoundOffWithMathRound(subTotalPRDetails)));
            const vatAmountPRDetails = Math.abs(prCallDetails?.get('vATAmount').value) - tableElement?.get('vATAmount').value;
            prCallDetails?.get('vATAmount').setValue(-Math.abs(toRoundOffWithMathRound(vatAmountPRDetails)));
            const totalAmountPRDetails = Math.abs(prCallDetails?.get('totalAmount').value) - tableElement?.get('totalAmount').value;
            prCallDetails?.get('totalAmount').setValue(-Math.abs(toRoundOffWithMathRound(totalAmountPRDetails)));
          }
          if (!tableElement?.get('billOfMaterialItemId').value) {
            findUnSavedItemId.push(tableElement?.get('itemId').value);
          }
        }
      } else {
        if (tableElement.get('IsWarranty').value) { // Warranty Discount
          if (!tableElement.get('checkBillOfMaterial').value && !tableElement.get('IsDeleted').value) {
            filteredArray.push(tableElement);
          } else if (tableElement.get('checkBillOfMaterial').value) {
            let requestQuantity = tableElement.get('stockType').value.toLowerCase() == 'y' ? +tableElement.get('reserved').value : +tableElement.get('used').value;
            if (discountStockDetails && tableElement.get('WarrantyQty').value) {
              if (requestQuantity == tableElement.get('WarrantyQty').value) {
                // if requestQuantity is same as WarrantyQty then subtract stock item's all prices from Warranty Discount
                const unitPriceDiscountStockDetails = Math.abs(discountStockDetails.get('unitPrice').value) - tableElement.get('unitPrice').value;
                discountStockDetails.get('unitPrice').setValue(-Math.abs(toRoundOffWithMathRound(unitPriceDiscountStockDetails)));
                const subTotalDiscountStockDetails = Math.abs(discountStockDetails.get('subTotal').value) - tableElement.get('subTotal').value;
                discountStockDetails.get('subTotal').setValue(-Math.abs(toRoundOffWithMathRound(subTotalDiscountStockDetails)));
                const vatAmountDiscountStockDetails = Math.abs(discountStockDetails.get('vATAmount').value) - tableElement.get('vATAmount').value;
                discountStockDetails.get('vATAmount').setValue(-Math.abs(toRoundOffWithMathRound(vatAmountDiscountStockDetails)));
                const totalAmountDiscountStockDetails = Math.abs(discountStockDetails.get('totalAmount').value) - tableElement.get('totalAmount').value
                discountStockDetails.get('totalAmount').setValue(-Math.abs(toRoundOffWithMathRound(totalAmountDiscountStockDetails)));
              } else {
                // setting values for final row ie. subtract from BOM Invoice
                let unitPriceForConsideredQty = +(toRoundOffWithMathRound(Math.abs(tableElement.get('unitPrice').value)));

                const result = calculateBOMPrice({
                  qty: tableElement.get('WarrantyQty').value, price: tableElement.get('unitPrice').value,
                  taxPercent: this.standardTax, roundFn: toRoundOffWithMathRound
                });

                // subtract from Warranty Discount
                discountStockDetails.get('unitPrice').setValue(-Math.abs(Math.abs(toRoundOffWithMathRound(discountStockDetails.get('unitPrice').value) - unitPriceForConsideredQty)));
                discountStockDetails.get('subTotal').setValue(-Math.abs(Math.abs(toRoundOffWithMathRound(discountStockDetails.get('subTotal').value) - result?.subTotal)));
                discountStockDetails.get('vATAmount').setValue(-Math.abs(Math.abs(toRoundOffWithMathRound(discountStockDetails.get('vATAmount').value) - result?.vatAmount)));
                discountStockDetails.get('totalAmount').setValue(-Math.abs(Math.abs(toRoundOffWithMathRound(discountStockDetails.get('totalAmount').value) - result?.totalAmount)));
              }
            }
            // If checked and IsWarranty is true, then remove stock code form warrantyMaintenanceDetailIndex array, and at // the end if warrantyMaintenanceDetailIndex lengh is zero, remove Discount Warranty from grid.
            let warrantyMaintenanceDetailIndex = this.warrantyMaintenanceDetail.findIndex(control => control.get('itemId').value.toLowerCase() == tableElement.get('itemId').value.toLowerCase());
            if (warrantyMaintenanceDetailIndex >= 0) {
              this.warrantyMaintenanceDetail.splice(warrantyMaintenanceDetailIndex, 1);
            }
            if (!tableElement?.get('billOfMaterialItemId').value) {
              findUnSavedItemId.push(tableElement?.get('itemId').value);
            }
            if (this.warrantyMaintenanceDetail.length == 0 && discountStockDetails) {
              discountStockDetails.get('IsDeleted').setValue(true);
            }
          }
        } else { // Normal Call
          if (!tableElement.get('checkBillOfMaterial').value && !tableElement.get('IsDeleted').value) {
            filteredArray.push(tableElement);
          }
        }
      }
      // if checkBillOfMaterial == true, then set isDeleted to true and checkBillOfMaterial to false
      if (tableElement.get('checkBillOfMaterial').value) {
        tableElement.get('IsDeleted').setValue(true);
        tableElement.get('checkBillOfMaterial').setValue(false, { emitEvent: false });
        if (!tableElement?.get('billOfMaterialItemId').value) {
          findUnSavedItemId.push(tableElement?.get('itemId').value);
        }
      }
    });
    findUnSavedItemId?.forEach(el => {
      let index = this.billOfMaterialItemsFormArray?.getRawValue()?.findIndex(el1 => el1?.itemId == el);
      this.billOfMaterialItemsFormArray?.removeAt(index);
    })
    this.onCalculateFinalTotal();
    this.updateBillOfMaterial();
    // this.getBillOfMaterialData();
    if (this.selectAll.checked) {
      this.selectAll.checked = false;
    }
  }

  getBillOfMaterialsRemove() {
    const arr = [];
    this.billOfMaterialItemsFormArray?.getRawValue().forEach(el => {
      if (el?.checkBillOfMaterial) {
        arr.push(el?.checkBillOfMaterial);
      }
      return el;
    })
    return arr?.length ? false : true;
  }

  getBillOfMaterialsDelete() {
    const arr = [];
    this.billOfMaterialItemsFormArray?.getRawValue().forEach(el => {
      if (el?.IsDeleted) {
        arr.push(el?.IsDeleted);
      }
      return el;
    })
    return arr?.length ? arr?.every(el => el == true) : false;
  }

  searchStockCodeBySerialNumber() {
    if (!this.getBOMActionPermission(PermissionTypes.ADD)) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    this.serialNumberError = false;
    let stockCodesData = this.billOfMaterialItemsFormArray;
    this.billOfMaterialForm.get('stockCodeSerialNumber').setValidators([Validators.required, Validators.minLength(1)]);
    this.billOfMaterialForm.get('stockCodeSerialNumber').updateValueAndValidity();
    if (this.billOfMaterialForm.get('stockCodeSerialNumber').invalid) {
      this.billOfMaterialForm.get('stockCodeSerialNumber').markAllAsTouched();
      return;
    }

    if (!this.billOfMaterialModel['technicianId']) {
      this.snackbarService.openSnackbar('Assign technician for this call');
      return;
    }

    for (let i = 0; i < this.goodsReturnData.length; i++) {
      if (this.goodsReturnData[i].hasOwnProperty('goodsReturnsItemsDetails') && this.goodsReturnData[i]['goodsReturnsItemsDetails'].length > 0) {
        let goodsReturnsItem = this.goodsReturnData[i]['goodsReturnsItemsDetails'].find(goodsReturnsItemsData => goodsReturnsItemsData['serialNumber'].toLowerCase() == this.billOfMaterialForm.get('stockCodeSerialNumber').value.toLowerCase() && goodsReturnsItemsData['goodsReturnItemDetailId']);
        if (goodsReturnsItem) {
          this.snackbarService.openSnackbar(`You can't add this serial number because GRV already completed in this serial number ${this.billOfMaterialForm.get('stockCodeSerialNumber').value}`)
          return;
        }
      }
    }
    let api = this.crudService.get(
      ModulesBasedApiSuffix.TECHNICIAN,
      TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_SEARCH_SERIAL_NUMBER,
      undefined,
      false,
      prepareGetRequestHttpParams('', '', {
        UserId: this.billOfMaterialModel['technicianId'],
        DistrictId: this.billOfMaterialModel['districtId'],
        SerialNumber: this.billOfMaterialForm.get('stockCodeSerialNumber').value,
        CallInitiationId: this.callInitiationId
      })
    )
    if (this.billOfMaterialModel?.isDealerCall) {
      api = this.crudService.get(
        ModulesBasedApiSuffix.TECHNICIAN,
        TechnicalMgntModuleApiSuffixModels.DEALER_BILL_OF_MATERIAL_VALIDATE_SERIAL_NUMBER,
        undefined,
        false,
        prepareGetRequestHttpParams('', '', {
          SerialNumber: this.billOfMaterialForm.get('stockCodeSerialNumber').value,
          CallInitiationId: this.callInitiationId
        })
      )
    }
    api.subscribe(response => {
      this.rxjsService.setGlobalLoaderProperty(false);
      if (response?.resources?.isSuccess) {
        if (response.isSuccess == true && response.statusCode == 200 && response.hasOwnProperty('resources') && response.resources) {
          let stockData = response.resources;
          this.searchScannedItemResponse = response.resources;
          const differenceAmount = this.otherService.transformCurrToNum(this.billOfMaterialForm.get('differenceAmount').value);
          let stockDetails = stockCodesData.controls.find(element => element.get('itemCode').value.toLowerCase() == stockData['itemCode'].toLowerCase());
          let stockIndex = stockCodesData.controls.findIndex((element, index) => element.get('itemCode').value.toLowerCase() == stockData['itemCode'].toLowerCase());
          if (stockDetails) {
            if (stockDetails.value.hasOwnProperty('billOfMaterialItemDetails') && stockDetails.value['billOfMaterialItemDetails'].length >= 0) {
              let serialNumberData = (<FormArray>stockDetails.get('billOfMaterialItemDetails')).controls.find(control => control.get('serialNumber').value.toLowerCase() === this.billOfMaterialForm.get('stockCodeSerialNumber').value.toLowerCase());
              const findAlreadyExistSerialNumber = this.serialNumberDataLocally?.find(el => this.billOfMaterialForm.get('stockCodeSerialNumber').value);
              if (serialNumberData && +stockDetails?.get('reserved').value > 0 && findAlreadyExistSerialNumber) {
                this.removeAlreadyScanSerialNumberLocally(stockIndex);
                return;
              }
            }
            this.searchScannedItemResponse.subTotal = this.searchScannedItemResponse?.costPrice;
            const result = calculateVatTotalBOMPrice({
              roundedSubTotal: this.searchScannedItemResponse.subTotal, taxPercent: this.standardTax,
              roundFn: toRoundOffWithMathRound
            });
            this.searchScannedItemResponse.vatAmount = result?.vatAmount;
            this.searchScannedItemResponse.totalAmount = result?.totalAmount;
            if (this.isNKACustomer && +this.searchScannedItemResponse?.totalAmount > Math.abs(differenceAmount)) { // NKA customer
              this.openNKARequestDialogWithScanning(stockDetails);
              return;
            }
            if ((this.billOfMaterialModel['isPRCall'] == true || this.billOfMaterialModel['isSaveOffer'] == true) && ((+stockDetails.get('subTotal').value > Math.abs(differenceAmount)) && stockDetails.get('request').value == 0 && stockDetails.get('transfer').value == 0)) {
              //   this.openPRCallWithScanning(stockDetails, stockCodesData);
              this.openPRRequestDialog(stockDetails, this.searchScannedItemResponse?.totalAmount);
              return;
            }
            if (stockDetails.value.hasOwnProperty('billOfMaterialItemDetails') && stockDetails.value['billOfMaterialItemDetails'].length >= 0) {
              let serialNumberData = (<FormArray>stockDetails.get('billOfMaterialItemDetails')).controls.find(control => control.get('serialNumber').value.toLowerCase() === this.billOfMaterialForm.get('stockCodeSerialNumber').value.toLowerCase());
              if (serialNumberData) {
                return;
              } else {
                let serialNumberFormGroup = this.createSerialNumberFormGroupToAddInGrid();
                serialNumberFormGroup.get('billOfMaterialItemId').setValue(stockDetails.get('billOfMaterialItemId').value);
                (<FormArray>stockDetails.get('billOfMaterialItemDetails')).push(serialNumberFormGroup);
              }
            } else {
              let billOfMaterialItemDetails = this.formBuilder.array([]);
              (<FormGroup>stockDetails).addControl('billOfMaterialItemDetails', billOfMaterialItemDetails);
              let serialNumberFormGroup = this.createSerialNumberFormGroupToAddInGrid();
              (<FormArray>stockDetails.get('billOfMaterialItemDetails')).push(serialNumberFormGroup);
            }
            if (((this.callType == '1' || this.isUpselling || this.isCounterSale) && !this.billOfMaterialModel?.isDealerCall) && +stockDetails.get('request').value <= 0 && +stockDetails.get('transfer').value <= 0) {
              this.isScanServiceCallDialog = true;
              return;
            }
            if (stockDetails.get('stockType').value.toLowerCase() == 'y') {
              stockDetails.get('reserved').setValue(stockDetails.get('reserved').value ? (+stockDetails.get('reserved').value + 1) : 1);
              if (+stockDetails.get('transfer').value > 0) {
                stockDetails.get('transfer').setValue(+stockDetails.get('transfer').value - 1);
              } else if (+stockDetails.get('request').value > 0) {
                stockDetails.get('request').setValue(+stockDetails.get('request').value - 1);
              }
            } else if (stockDetails.get('stockType').value.toLowerCase() == 'm') {
              stockDetails.get('used').setValue(stockDetails.get('used').value ?
                (+stockDetails.get('used').value + 1) : 1);
              if (+stockDetails.get('transfer').value > 0) {
                stockDetails.get('transfer').setValue(+stockDetails.get('transfer').value - 1);
              } else if (+stockDetails.get('request').value > 0) {
                stockDetails.get('request').setValue(+stockDetails.get('request').value - 1);
              }
            }
            let stockDetailsCopy = new FormGroup({});
            Object.keys(stockDetails?.value).forEach((key) => {
              stockDetailsCopy.addControl(key, new FormControl(stockDetails.value[key]));
            });
            const reqQty = +stockDetails.get('used').value + +stockDetails.get('request').value + +stockDetails.get('transfer').value + +stockDetails.get('reserved').value + +stockDetails.get('invoice').value;
            stockDetails.get('unitPrice').setValue(this.otherService.transformDecimal(stockDetails.get('unitPrice').value));
            const unitPrice = this.otherService.transformCurrToNum(stockDetails.get('unitPrice').value);
            const serialResult = calculateBOMPrice({ qty: reqQty, price: unitPrice, taxPercent: this.standardTax, roundFn: toRoundOffWithMathRound });
            stockDetails.get('subTotal').setValue(this.otherService.transformDecimal(serialResult?.subTotal));
            stockDetails.get('vATAmount').setValue(this.otherService.transformDecimal(serialResult?.vatAmount));
            stockDetails.get('totalAmount').setValue(this.otherService.transformDecimal(serialResult?.totalAmount));
            this.billOfMaterialItemsFormArray.controls[stockIndex].patchValue(
              stockDetails.value
            )
            if (stockData['itemName'].toLowerCase() == 'servicing discount technical') {
              //     stockDetails = this.performServicingDiscountTechnicalOperation(stockDetails);
            }
            if (!this.billOfMaterialModel['isPRCall'] && !this.billOfMaterialModel['isPRcallSaveOfferMaxCount']) {
              // Discount Warranties starts
              this.onDiscountWarrantyCheck(stockData, stockCodesData, stockDetailsCopy, stockIndex, true);
            }
            // }
          } else {
            if (this.billOfMaterialModel?.isCounterSale) {
              return this.snackbarService.openSnackbar("We can't add the new stock in counter sale call");
            }
            let stockCodeBySerialNumberFormGroup = this.createFormGroupToAddInGrid();
            stockCodeBySerialNumberFormGroup.get('stockTypeId').setValue(stockData['stockTypeId']);
            stockCodeBySerialNumberFormGroup.get('stockType').setValue(stockData['stockType']);
            stockCodeBySerialNumberFormGroup.get('itemId').setValue(stockData['itemId']);
            stockCodeBySerialNumberFormGroup.get('itemCode').setValue(stockData['itemCode']);
            stockCodeBySerialNumberFormGroup.get('itemName').setValue(stockData['itemName']);
            stockCodeBySerialNumberFormGroup.get('unitPrice').setValue(stockData['costPrice']);
            stockCodeBySerialNumberFormGroup.get('itemPricingConfigId').setValue(stockData['itemPricingConfigId']);
            if (stockCodeBySerialNumberFormGroup.get('stockType').value.toLowerCase() == 'y') {
              stockCodeBySerialNumberFormGroup.get('reserved').setValue(stockCodeBySerialNumberFormGroup.get('reserved').value ? (+stockCodeBySerialNumberFormGroup.get('reserved').value + 1) : 1);
              if (+stockCodeBySerialNumberFormGroup.get('transfer').value > 0) {
                stockCodeBySerialNumberFormGroup.get('transfer').setValue(+stockCodeBySerialNumberFormGroup.get('transfer').value - 1);
              } else if (+stockCodeBySerialNumberFormGroup.get('request').value > 0) {
                stockCodeBySerialNumberFormGroup.get('request').setValue(+stockCodeBySerialNumberFormGroup.get('request').value - 1);
              }
            } else if (stockCodeBySerialNumberFormGroup.get('stockType').value.toLowerCase() == 'm') {
              stockCodeBySerialNumberFormGroup.get('used').setValue(stockCodeBySerialNumberFormGroup.get('used').value ?
                (+stockCodeBySerialNumberFormGroup.get('used').value + 1) : 1);
              if (+stockCodeBySerialNumberFormGroup.get('transfer').value > 0) {
                stockCodeBySerialNumberFormGroup.get('transfer').setValue(+stockCodeBySerialNumberFormGroup.get('transfer').value - 1);
              } else if (+stockCodeBySerialNumberFormGroup.get('request').value > 0) {
                stockCodeBySerialNumberFormGroup.get('request').setValue(+stockCodeBySerialNumberFormGroup.get('request').value - 1);
              }
            }
            stockCodeBySerialNumberFormGroup.get('subTotal').setValue(stockCodeBySerialNumberFormGroup.get('unitPrice').value);
            const result = calculateVatTotalBOMPrice({
              roundedSubTotal: stockCodeBySerialNumberFormGroup.get('subTotal').value, taxPercent: this.standardTax,
              roundFn: toRoundOffWithMathRound
            });
            stockCodeBySerialNumberFormGroup.get('vATAmount').setValue(result?.vatAmount);
            stockCodeBySerialNumberFormGroup.get('totalAmount').setValue(result?.totalAmount);
            // if installation call, if current stock item's amount + previous total amount > target order amount then show
            // warning and dont allow to add stock item in grid else allow it to add
            // this only applicable to installation call
            if ((this.callType == '1' || this.isUpselling || this.isCounterSale) && !this.billOfMaterialModel?.isDealerCall && (Math.abs(stockCodeBySerialNumberFormGroup.get('totalAmount').value) + +this.billOfMaterialForm.get('bomInvoice.totalAmount').value) > +this.billOfMaterialForm.get('targetOrderAmount').value) {
              this.isScanServiceCallDialog = true;
              return;
            }
            // conditions start
            if (this.billOfMaterialModel['isPRCall'] == true || this.billOfMaterialModel['isSaveOffer'] == true) {
              this.openPRCallWithScanning(stockCodeBySerialNumberFormGroup, stockCodesData);
            } else if (this.isNKACustomer && +stockCodeBySerialNumberFormGroup.get('totalAmount').value > Math.abs(differenceAmount)) { // NKA customer
              this.openNKARequestDialogWithScanning(stockCodeBySerialNumberFormGroup);
            } else {
              if (stockData['itemName'].toLowerCase() == 'servicing discount technical') {
                stockCodeBySerialNumberFormGroup = this.performServicingDiscountTechnicalOperation(stockCodeBySerialNumberFormGroup);
              }
              if (!this.billOfMaterialModel['isPRCall'] && !this.billOfMaterialModel['isPRcallSaveOfferMaxCount']) {
                // Discount Warranties starts
                this.onDiscountWarrantyCheck(stockData, stockCodesData, stockCodeBySerialNumberFormGroup, stockIndex);
              }
            }
          }
          if (stockData?.stockType?.toLowerCase() == "y") {
            this.onCalculateFinalTotal();
            if (stockData?.isDecoder) {
              this.openDecoderAddEditDialog();
            } else {
              this.openZoneAddEditDialog();
            }
            this.serialNumberDataLocally.push({ serialNo: this.billOfMaterialForm.get('stockCodeSerialNumber').value });
          }
        }
      } else if (response?.resources?.isSameBillOfMaterial && response?.resources?.validateMessage) {
        this.removeAlreadyInstalledItem(response?.resources);
      } else if (response?.resources?.validateMessage) {
        this.snackbarService.openSnackbar(response?.resources?.validateMessage)
        return;
      }
    });
  }

  openPRCallWithScanning(stockCodeBySerialNumberFormGroup, stockCodesData) {
    const totalAmount = +stockCodeBySerialNumberFormGroup.get('subTotal').value + +stockCodeBySerialNumberFormGroup.get('vATAmount').value;
    const differenceAmount = this.otherService.transformCurrToNum(this.billOfMaterialForm.get('differenceAmount').value);
    if (+stockCodeBySerialNumberFormGroup.get('subTotal').value > Math.abs(differenceAmount)) {
      this.openPRRequestDialog(stockCodeBySerialNumberFormGroup, totalAmount);
    } else {
      let prCallDetails = stockCodesData.controls.find(element => (element.get('itemId').value == this.billOfMaterialModel['prCallDiscountItemId'] && this.billOfMaterialModel['isPRCall']) ||
        (element.get('itemId').value == this.billOfMaterialModel['saveOfferDiscountItemId'] && this.billOfMaterialModel['isSaveOffer']));
      if (prCallDetails) {
        const unitPricePRDetails = Math.abs(prCallDetails.get('unitPrice').value) + +stockCodeBySerialNumberFormGroup.get('unitPrice').value;
        prCallDetails.get('unitPrice').setValue(-Math.abs(toRoundOffWithMathRound(unitPricePRDetails)));
        const subTotalPRDetails = Math.abs(prCallDetails.get('subTotal').value) + +stockCodeBySerialNumberFormGroup.get('subTotal').value;
        prCallDetails.get('subTotal').setValue(-Math.abs(toRoundOffWithMathRound(subTotalPRDetails)));
        const vatAmountPRDetails = Math.abs(prCallDetails.get('vATAmount').value) + +stockCodeBySerialNumberFormGroup.get('vATAmount').value;
        prCallDetails.get('vATAmount').setValue(-Math.abs(toRoundOffWithMathRound(vatAmountPRDetails)));
        const totalAmountPRDetails = Math.abs(prCallDetails.get('totalAmount').value) + +stockCodeBySerialNumberFormGroup.get('totalAmount').value
        prCallDetails.get('totalAmount').setValue(-Math.abs(toRoundOffWithMathRound(totalAmountPRDetails)));
        this.billOfMaterialForm.get('bomInvoice.totalAmount').setValue('R 0.00');
        this.sortStockCodes(stockCodeBySerialNumberFormGroup);
      }
    }
  }

  openPRRequestDialog(stockCodeBySerialNumberFormGroup, totalAmount) {
    if (this.billOfMaterialModel.serviceCallRequestId) {
      this.crudService.get(
        ModulesBasedApiSuffix.TECHNICIAN,
        TechnicalMgntModuleApiSuffixModels.PR_CALL,
        null, null, prepareRequiredHttpParams({ serviceCallRequestId: this.billOfMaterialModel.serviceCallRequestId, callInitiationId: this.billOfMaterialModel.callInitiationId })
      ).subscribe((response: IApplicationResponse) => {
        if (response?.isSuccess && response?.statusCode == 200) {
          let equipments = null
          if (response.resources)
            equipments = response.resources.equipments;
          if (equipments && equipments.length > 0) {
            let equipmentsArr = equipments.filter(x => x.itemId == stockCodeBySerialNumberFormGroup?.get('itemId').value);
            if (equipmentsArr && equipmentsArr.length > 0) {
              this.snackbarService.openSnackbar('Stock Code is already added Try adding other Stock Code');
              this.rxjsService.setGlobalLoaderProperty(false);
              return;
            } else {
              let data = {
                stockType: this.stockCodeDescriptionForm?.get('stockType')?.value,
                billOfMaterialModel: this.billOfMaterialModel,
                standardTax: this.standardTax,
                userId: this.userData?.userId,
                newData: {
                  itemId: stockCodeBySerialNumberFormGroup?.get('itemId').value,
                  stockCode: stockCodeBySerialNumberFormGroup?.get('itemCode').value,
                  stockDesc: stockCodeBySerialNumberFormGroup?.get('itemName').value,
                  stockQty: 1,
                  stockUnitPriceExVat: stockCodeBySerialNumberFormGroup?.get('unitPrice').value,
                  subTotalExclVat: stockCodeBySerialNumberFormGroup?.get('subTotal').value,
                  subTotalInclVat: totalAmount,
                  itemPricingConfigId: stockCodeBySerialNumberFormGroup?.get('itemPricingConfigId').value
                },
                resources: response?.resources,
              }
              this.openPRCallDynamicDialog(data);
            }
          } else {
            let data = {
              stockType: this.stockCodeDescriptionForm?.get('stockType')?.value,
              billOfMaterialModel: this.billOfMaterialModel,
              standardTax: this.standardTax,
              userId: this.userData?.userId,
              newData: {
                itemId: stockCodeBySerialNumberFormGroup?.get('itemId').value,
                stockCode: stockCodeBySerialNumberFormGroup?.get('itemCode').value,
                stockDesc: stockCodeBySerialNumberFormGroup?.get('itemName').value,
                stockQty: 1,
                stockUnitPriceExVat: stockCodeBySerialNumberFormGroup?.get('unitPrice').value,
                subTotalExclVat: stockCodeBySerialNumberFormGroup?.get('subTotal').value,
                subTotalInclVat: totalAmount,
                itemPricingConfigId: stockCodeBySerialNumberFormGroup?.get('itemPricingConfigId').value
              },
            }
            this.openPRCallDynamicDialog(data);
          }
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
    } else {
      let data = {
        stockType: this.stockCodeDescriptionForm?.get('stockType')?.value,
        billOfMaterialModel: this.billOfMaterialModel,
        standardTax: this.standardTax,
        userId: this.userData?.userId,
        newData: {
          itemId: stockCodeBySerialNumberFormGroup?.get('itemId').value,
          stockCode: stockCodeBySerialNumberFormGroup?.get('itemCode').value,
          stockDesc: stockCodeBySerialNumberFormGroup?.get('itemName').value,
          stockQty: 1,
          stockUnitPriceExVat: stockCodeBySerialNumberFormGroup?.get('unitPrice').value,
          subTotalExclVat: stockCodeBySerialNumberFormGroup?.get('subTotal').value,
          subTotalInclVat: totalAmount,
          itemPricingConfigId: stockCodeBySerialNumberFormGroup?.get('itemPricingConfigId').value
        },
      }
      this.openPRCallDynamicDialog(data);
    }
  }

  openNKARequestDialogWithScanning(stockCodeBySerialNumberFormGroup) {
    const unitPrice = this.otherService.transformCurrToNum(stockCodeBySerialNumberFormGroup.get('unitPrice').value);
    const result = calculateBOMPrice({ qty: 1, price: unitPrice, taxPercent: this.standardTax, roundFn: toRoundOffWithMathRound });
    this.rxjsService.setGlobalLoaderProperty(true);
    this.crudService.get(
      ModulesBasedApiSuffix.TECHNICIAN,
      TechnicalMgntModuleApiSuffixModels.NKA_SERVICE_CALL_PURCHASE_ORDER,
      null, null, prepareRequiredHttpParams({ callInitiationId: this.billOfMaterialModel.callInitiationId }))
      .subscribe((response: IApplicationResponse) => {
        if (response?.isSuccess && response?.statusCode == 200) {
          let data = {
            stockType: this.stockCodeDescriptionForm?.get('stockType')?.value,
            billOfMaterialModel: this.billOfMaterialModel,
            tax: this.standardTax,
            userId: this.userData?.userId,
            newData: {
              NKAPurchaseOrderRequestItemId: null,
              NKAPurchaseOrderRequestId: null,
              itemId: stockCodeBySerialNumberFormGroup?.get('itemId').value,
              itemCode: stockCodeBySerialNumberFormGroup?.get('itemCode').value,
              itemName: stockCodeBySerialNumberFormGroup?.get('itemName').value,
              quantity: 1,
              unitPriceExclVat: stockCodeBySerialNumberFormGroup?.get('unitPrice').value,
              subTotalExclVat: result?.subTotal,
              subTotalInclVat: result?.totalAmount,
              itemPricingConfigId: stockCodeBySerialNumberFormGroup?.get('itemPricingConfigId').value
            },
            response: response?.resources,
          }
          this.openNKADoaRequestDialog(data);
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      })
  }

  onDiscountWarrantyCheck(stockData, stockCodesData, stockCodeBySerialNumberFormGroup, stockIndex, isExist = false) {
    this.crudService.get(
      ModulesBasedApiSuffix.TECHNICIAN,
      TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_WARRANTY_CHECK,
      undefined,
      false,
      prepareGetRequestHttpParams('', '', {
        CallInitiationId: this.callInitiationId,
        ItemId: stockCodeBySerialNumberFormGroup.get('itemId').value,
        StockTypeId: stockCodeBySerialNumberFormGroup.get('stockTypeId').value
      })
    ).subscribe((response: IApplicationResponse) => {
      this.rxjsService.setGlobalLoaderProperty(false);
      if (response.isSuccess == true && response.statusCode == 200 && !response?.message) {
        let discountStockDetails = stockCodesData.controls.find(element => element.get('itemId').value.toLowerCase() == response.resources['itemId'].toLowerCase());
        if (response.resources['isWarranty'] || response.resources['isDiscountMaintenance']) {
          stockCodeBySerialNumberFormGroup.get('IsWarranty').setValue(true);
          if (stockCodeBySerialNumberFormGroup.get('reserved').value > response?.resources?.warrantyQty) {
            return;
          }
          stockCodeBySerialNumberFormGroup.get('WarrantyQty').setValue(+stockCodeBySerialNumberFormGroup.get('WarrantyQty').value + 1);
          if (stockIndex != -1) {
            this.billOfMaterialItemsFormArray.controls[stockIndex].get('WarrantyQty').setValue(+this.billOfMaterialItemsFormArray.controls[stockIndex].get('WarrantyQty').value + 1);
          }
          this.warrantyMaintenanceDetail.push(stockCodeBySerialNumberFormGroup);
        }
        if (discountStockDetails == undefined && (response.resources['isWarranty'] || response.resources['isDiscountMaintenance'])) {
          let serialNumberlWarrantyItemFormGroup = this.createFormGroupToAddInGrid();
          serialNumberlWarrantyItemFormGroup.get('stockTypeId').setValue(response.resources['stockTypeId']);
          serialNumberlWarrantyItemFormGroup.get('stockType').setValue(response.resources['stockType']);
          serialNumberlWarrantyItemFormGroup.get('itemId').setValue(response.resources['itemId']);
          serialNumberlWarrantyItemFormGroup.get('itemCode').setValue(response.resources['itemCode']);
          serialNumberlWarrantyItemFormGroup.get('itemName').setValue(response.resources['itemName']);
          serialNumberlWarrantyItemFormGroup.get('unitPrice').setValue(-Math.abs(toRoundOffWithMathRound(stockData['costPrice'])));
          serialNumberlWarrantyItemFormGroup.get('subTotal').setValue(-Math.abs(toRoundOffWithMathRound(stockData['costPrice'])));
          const result = calculateVatTotalBOMPrice({ roundedSubTotal: stockData['costPrice'], taxPercent: this.standardTax, roundFn: toRoundOffWithMathRound });
          serialNumberlWarrantyItemFormGroup.get('vATAmount').setValue(-Math.abs(result?.vatAmount));
          serialNumberlWarrantyItemFormGroup.get('totalAmount').setValue(-Math.abs(result?.totalAmount));
          if (serialNumberlWarrantyItemFormGroup.get('stockType').value.toLowerCase() == 'y') {
            serialNumberlWarrantyItemFormGroup.get('reserved').setValue(1);
          } else if (serialNumberlWarrantyItemFormGroup.get('stockType').value?.toLowerCase() == 'm') {
            serialNumberlWarrantyItemFormGroup.get('used').setValue(1);
          }
          serialNumberlWarrantyItemFormGroup.get('WarrantyQty').setValue(+serialNumberlWarrantyItemFormGroup.get('WarrantyQty').value + 1);
          stockCodesData.push(serialNumberlWarrantyItemFormGroup);
        } else if (discountStockDetails != undefined && (response.resources['isWarranty'] || response.resources['isDiscountMaintenance'])) {
          // Related to Discount Warrenties other than 1st time
          discountStockDetails.get('WarrantyQty').setValue(+discountStockDetails.get('WarrantyQty').value + 1);
          discountStockDetails.get('unitPrice').setValue((-Math.abs(Math.abs(+discountStockDetails.get('unitPrice').value) + this.otherService.transformCurrToNum(stockCodeBySerialNumberFormGroup.get('unitPrice').value))));
          discountStockDetails.get('subTotal').setValue((-Math.abs(Math.abs(+discountStockDetails.get('unitPrice').value))));
          const result = calculateVatTotalBOMPrice({ roundedSubTotal: discountStockDetails.get('unitPrice').value, taxPercent: this.standardTax, roundFn: toRoundOffWithMathRound });
          discountStockDetails.get('vATAmount').setValue(result?.vatAmount);
          discountStockDetails.get('totalAmount').setValue(result?.totalAmount);
        }
      }
      // add serial number without item exists in table
      if (!isExist) {
        let billOfMaterialItemDetails = this.formBuilder.array([]);
        stockCodeBySerialNumberFormGroup.addControl('billOfMaterialItemDetails', billOfMaterialItemDetails);
        let serialNumberFormGroup: any = this.createSerialNumberFormGroupToAddInGrid();
        serialNumberFormGroup.get('IsWarrenty').setValue(stockCodeBySerialNumberFormGroup.get('IsWarranty').value);
        (<FormArray>stockCodeBySerialNumberFormGroup.get('billOfMaterialItemDetails')).push(serialNumberFormGroup);
        this.sortStockCodes(stockCodeBySerialNumberFormGroup);
      } else {
        const findSerialIndex = this.billOfMaterialItemsFormArray.controls[stockIndex].get('billOfMaterialItemDetails').value?.findIndex(el => el?.serialNumber == this.billOfMaterialForm?.get('stockCodeSerialNumber')?.value)
        this.billOfMaterialItemsFormArray.controls[stockIndex].get('billOfMaterialItemDetails')['controls'][findSerialIndex].get('IsWarrenty').setValue(stockCodeBySerialNumberFormGroup.get('IsWarranty').value);
      }
      this.onCalculateFinalTotal();
    });
  }

  removeAlreadyScanSerialNumberLocally(i: number) {
    const message = `Item has been scanned already, Would you like to remove the item from bill of materials?`;
    const dialogData = new ConfirmDialogModel("Notification", message);
    const dialogRef = this.dialog.open(ConfirmDialogPopupComponent, {
      width: "500px",
      data: {
        ...dialogData,
        isClose: true,
        msgCenter: true,
        isConfirm: true,
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.onRemoveWarrantyItem(i);
        let findIndex = this.serialNumberDataLocally?.findIndex(el => el?.serialNo == this.billOfMaterialForm?.get('stockCodeSerialNumber')?.value);
        this.serialNumberDataLocally?.splice(findIndex, 1);
        let findSerialItemIndex = (<FormArray>(<FormGroup>this.billOfMaterialItemsFormArray.controls[i])?.get('billOfMaterialItemDetails'))?.controls?.findIndex(el => el?.get('serialNumber').value == this.billOfMaterialForm?.get('stockCodeSerialNumber')?.value);
        (<FormArray>(<FormGroup>this.billOfMaterialItemsFormArray.controls[i])?.get('billOfMaterialItemDetails')).removeAt(findSerialItemIndex);
        if (!(<FormArray>(<FormGroup>this.billOfMaterialItemsFormArray.controls[i])?.get('billOfMaterialItemDetails'))?.length) {
          (<FormGroup>this.billOfMaterialItemsFormArray.controls[i]).removeControl('billOfMaterialItemDetails');
        }
        this.billOfMaterialForm?.get('stockCodeSerialNumber')?.setValue('');
        this.billOfMaterialForm?.get('stockCodeSerialNumber')?.markAsUntouched();
        this.onCalculateFinalTotal();
      }
    })
  }

  removeAlreadyInstalledItem(response: any) {
    const message = `Item has been scanned already, Would you like to remove the item from bill of materials?`;
    const dialogData = new ConfirmDialogModel("Notification", message);
    const dialogRef = this.dialog.open(ConfirmDialogPopupComponent, {
      width: "500px",
      data: {
        ...dialogData,
        isClose: true,
        msgCenter: true,
        isConfirm: true,
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        const index = this.billOfMaterialItemsFormArray.getRawValue()?.findIndex(el => el?.billOfMaterialItemId == response?.billOfMaterialItemId);
        if (index != -1) {
          this.onRemoveWarrantyItem(index, response?.isWarranty);
          this.onCalculateFinalTotal();
        }
        this.removeBillOfMaterialBySerialNo(response?.isDecoder);
      }
    })
  }

  onRemoveWarrantyItem(i: number, isWarranty = false) {
    let findItemDiscountWarrenty = (<FormArray>(<FormGroup>this.billOfMaterialItemsFormArray.controls[i])?.get('billOfMaterialItemDetails'))?.controls?.find(el => el?.get('serialNumber').value == this.billOfMaterialForm?.get('stockCodeSerialNumber')?.value);
    if ((findItemDiscountWarrenty?.get('IsWarrenty')?.value || ((<FormGroup>this.billOfMaterialItemsFormArray.controls[i])?.get('IsWarranty').value && isWarranty)) && this.billOfMaterialItemsFormArray.controls[i].get('WarrantyQty').value) {
      const j = this.billOfMaterialItemsFormArray.getRawValue().findIndex(el => el?.itemId?.toLowerCase() == this.billOfMaterialModel?.discountWithinWarrantyItemId);
      const unitPrice = Math.abs(this.otherService.transformCurrToNum((<FormGroup>this.billOfMaterialItemsFormArray.controls[j])?.get('unitPrice').value)) -
        this.otherService.transformCurrToNum((<FormGroup>this.billOfMaterialItemsFormArray.controls[i])?.get('unitPrice').value);
      const vATAmount = this.otherService.transformCurrToNum(unitPrice * (this.standardTax / 100));
      const totalAmount = this.otherService.transformCurrToNum(unitPrice + vATAmount);
      (<FormGroup>this.billOfMaterialItemsFormArray.controls[j])?.get('WarrantyQty').setValue(+this.billOfMaterialItemsFormArray.controls[j].get('WarrantyQty').value - 1);
      (<FormGroup>this.billOfMaterialItemsFormArray.controls[j])?.get('unitPrice').setValue(-Math.abs(unitPrice));
      (<FormGroup>this.billOfMaterialItemsFormArray.controls[j])?.get('subTotal').setValue(-Math.abs(unitPrice));
      (<FormGroup>this.billOfMaterialItemsFormArray.controls[j])?.get('vATAmount').setValue(-Math.abs(vATAmount));
      (<FormGroup>this.billOfMaterialItemsFormArray.controls[j])?.get('totalAmount').setValue(-Math.abs(totalAmount));
      if (this.callType == '1') {
        this.billOfMaterialItemsFormArray.controls[i].get('transfer').setValue(+this.billOfMaterialItemsFormArray.controls[i].get('transfer').value + 1);
      } else {
        this.billOfMaterialItemsFormArray.controls[i].get('request').setValue(+this.billOfMaterialItemsFormArray.controls[i].get('request').value + 1);
      }
      this.billOfMaterialItemsFormArray.controls[i].get('reserved').setValue(+this.billOfMaterialItemsFormArray.controls[i].get('reserved').value - 1);
      this.billOfMaterialItemsFormArray.controls[i].get('WarrantyQty').setValue(+this.billOfMaterialItemsFormArray.controls[i].get('WarrantyQty').value - 1);
    } else {
      if (this.callType == '1') {
        this.billOfMaterialItemsFormArray.controls[i].get('transfer').setValue(+this.billOfMaterialItemsFormArray.controls[i].get('transfer').value + 1);
      } else {
        this.billOfMaterialItemsFormArray.controls[i].get('request').setValue(+this.billOfMaterialItemsFormArray.controls[i].get('request').value + 1);
      }
      this.billOfMaterialItemsFormArray.controls[i].get('reserved').setValue(+this.billOfMaterialItemsFormArray.controls[i].get('reserved').value - 1);
    }
  }

  removeZoneData(isDecoder: boolean) {
    let otherParams = { customerAddressId: this.customerAddressId, serialNo: this.billOfMaterialForm.get('stockCodeSerialNumber').value, ModifiedUserId: this.userData?.userId, customerId: this.customerId };
    let api = this.crudService.delete(ModulesBasedApiSuffix.EVENT_MANAGEMENT, EventMgntModuleApiSuffixModels.ZONE_EQUIPMENT_MAPPING_SERIAL_NUMBER, null,
      prepareRequiredHttpParams(otherParams));
    if (isDecoder) {
      api = this.crudService.delete(ModulesBasedApiSuffix.EVENT_MANAGEMENT, EventMgntModuleApiSuffixModels.CUSTOMER_ACCOUNT, null,
        prepareRequiredHttpParams(otherParams));
    }
    api.subscribe((res: IApplicationResponse) => {
      if (res?.isSuccess && res?.statusCode == 200) {
      }
    })
  }

  removeBillOfMaterialBySerialNo(isDecoder: boolean) {
    const removeObj = {
      billOfMaterialId: this.billOfMaterialModel['billOfMaterialId'],
      serialNo: this.billOfMaterialForm.get('stockCodeSerialNumber').value,
      modifiedUserId: this.userData?.userId,
    }
    this.crudService.delete(ModulesBasedApiSuffix.TECHNICIAN, TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_SERIALNUMBER, null,
      prepareRequiredHttpParams(removeObj))
      .subscribe((res: IApplicationResponse) => {
        if (res?.isSuccess && res?.statusCode == 200) {
          this.updateBillOfMaterial();
          // this.getBillOfMaterialData();
          this.removeZoneData(isDecoder);
        } else {
          this.getBillOfMaterialData();
        }
      })
  }

  openDecoderAddEditDialog() {
    this.rxjsService.setCustomerDate({ customerId: this.customerId });
    this.rxjsService.setCustomerAddresId(this.customerAddressId);
    const editableObject = {
      isShowPartition: true,
      serialNo: this.billOfMaterialForm?.get('stockCodeSerialNumber')?.value,
      callInitiationId: this.callInitiationId,
      partitionId: this.partitionId,
      technicianId: this.billOfMaterialModel?.technicianId,
      header: 'Decoders',
      customerId: this.customerId, addressId: this.customerAddressId
    }
    const ref = this.dialogService.open(CustomerDecoderAddDialogComponent, {
      showHeader: false,
      baseZIndex: 1000,
      width: '650px',
      data: editableObject
    });
    ref.onClose.subscribe(result => {
      // if (result) {
      this.updateBillOfMaterial();
      // }
      this.billOfMaterialForm?.get('stockCodeSerialNumber')?.setValue('');
      this.billOfMaterialForm?.get('stockCodeSerialNumber')?.markAsUntouched();
    });
  }

  openZoneAddEditDialog() {
    this.rxjsService.setCustomerDate({ customerId: this.customerId });
    this.rxjsService.setCustomerAddresId(this.customerAddressId);
    const editableObject = {
      isShowPartition: true,
      serialNo: this.billOfMaterialForm?.get('stockCodeSerialNumber')?.value,
      callInitiationId: this.callInitiationId,
      partitionId: this.partitionId,
      itemId: this.searchScannedItemResponse?.itemId,
      itemOwnershipTypeId: this.searchScannedItemResponse?.itemOwnershipTypeId,
      customerId: this.customerId,
      customerAddressId: this.customerAddressId,
    }
    const ref = this.dialogService.open(CustomerZoneAddEditComponent, { showHeader: false, baseZIndex: 1000, width: '700px', data: editableObject });
    ref.onClose.subscribe(result => {
      // if (result) {
      this.updateBillOfMaterial();
      // }
      this.billOfMaterialForm?.get('stockCodeSerialNumber')?.setValue('');
      this.billOfMaterialForm?.get('stockCodeSerialNumber')?.markAsUntouched();
    });
  }

  createFormGroupToAddInGrid(): FormGroup {
    return this.formBuilder.group({
      billOfMaterialItemId: '',
      billOfMaterialId: this.billOfMaterialModel['billOfMaterialId'],
      checkBillOfMaterial: false,
      IsDeleted: false,
      invoice: 0,
      transfer: 0,
      used: 0,
      reserved: 0,
      request: 0,
      subTotal: 0,
      vATAmount: 0,
      totalAmount: 0,
      unitPrice: 0,
      IsWarranty: false,
      WarrantyQty: 0,
      stockTypeId: '',
      stockType: '',
      itemId: '',
      itemCode: '',
      itemName: '',
      kitConfigId: null,
      kitTypeName: null,
      systemTypeId: '',
      itemPricingConfigId: '',
      createdUserId: this.userData?.userId,
      modifiedUserId: this.userData?.userId,
      isNotSerialized: false,
    });
  }

  createSerialNumberFormGroupToAddInGrid(): FormGroup {
    return this.formBuilder.group({
      billOfMaterialItemDetailId: null,
      billOfMaterialItemId: null,
      serialNumber: this.billOfMaterialForm.get('stockCodeSerialNumber').value,
      createdUserId: this.userData?.userId,
      modifiedUserId: this.userData?.userId,
      IsWarrenty: false,
    });
  }

  performServicingDiscountTechnicalOperation(billOfMaterialItemFormGroup): FormGroup {
    billOfMaterialItemFormGroup.get('unitPrice').patchValue(this.stockCodeDescriptionForm.get('stockUnitPriceExcl').value);
    billOfMaterialItemFormGroup.get('subTotal').setValue('R 0.00');
    billOfMaterialItemFormGroup.get('vATAmount').setValue('R 0.00');
    billOfMaterialItemFormGroup.get('totalAmount').setValue('R 0.00');
    return billOfMaterialItemFormGroup;
  }

  sortStockCodes(billOfMaterialFormGroup: FormGroup) {
    // let billOfMaterialItemsFormArray = this.billOfMaterialItemsFormArray;
    let stockIndex = -1;
    let startIndex = 0;
    let finalIndex = 0
    if (billOfMaterialFormGroup.value['stockType'].toLowerCase() == 'y') {
      stockIndex = this.billOfMaterialItemsFormArray.value.map(element => element['stockType'].toLowerCase()).lastIndexOf('y');
      startIndex = 0;
      finalIndex = stockIndex;
    } else {
      stockIndex = this.billOfMaterialItemsFormArray.value.map(element => element['stockType'].toLowerCase()).indexOf('m');
      // lastIndexOf
      startIndex = stockIndex;
      finalIndex = this.billOfMaterialItemsFormArray.length == 0 ? 0 : this.billOfMaterialItemsFormArray.length - 1;
    }
    if (billOfMaterialFormGroup.value['stockType'].toLowerCase() == 'y' && finalIndex < 0) { // finalIndex < startIndex
      // in case of y and no y stock item present initially
      this.billOfMaterialItemsFormArray.insert(startIndex, billOfMaterialFormGroup);
      if (this.billOfMaterialModel?.bomQuotationItems?.length) {
        this.billOfMaterialModel?.bomQuotationItems?.splice(startIndex, 0, billOfMaterialFormGroup?.getRawValue());
      }
      this.onCalculateFinalTotal();
      return;
    }
    if (billOfMaterialFormGroup.value['stockType'].toLowerCase() == 'm' && startIndex < 0) {
      // in case of m and no m stock item present initially
      this.billOfMaterialItemsFormArray.insert((finalIndex + 1), billOfMaterialFormGroup);
      if (this.billOfMaterialModel?.bomQuotationItems?.length) {
        this.billOfMaterialModel?.bomQuotationItems?.splice((finalIndex + 1), 0, billOfMaterialFormGroup?.getRawValue());
      }
      this.onCalculateFinalTotal();
      return;
    }
    for (startIndex; startIndex <= finalIndex; startIndex++) {
      if (this.otherService.transformCurrToNum(billOfMaterialFormGroup.get('unitPrice').value) > this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray.controls[startIndex].get('unitPrice').value)) {
        this.billOfMaterialItemsFormArray.insert(startIndex, billOfMaterialFormGroup);
        if (this.billOfMaterialModel?.bomQuotationItems?.length) {
          this.billOfMaterialModel?.bomQuotationItems?.splice(startIndex, 0, billOfMaterialFormGroup?.getRawValue());
        }
        this.onCalculateFinalTotal();
        break;
      } else {
        if (startIndex == finalIndex && this.otherService.transformCurrToNum(billOfMaterialFormGroup.get('unitPrice').value) <= this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray.controls[startIndex].get('unitPrice').value)) {
          this.billOfMaterialItemsFormArray.insert((finalIndex + 1), billOfMaterialFormGroup);
          if (this.billOfMaterialModel?.bomQuotationItems?.length) {
            this.billOfMaterialModel?.bomQuotationItems?.splice((finalIndex + 1), 0, billOfMaterialFormGroup?.getRawValue());
          }
          this.onCalculateFinalTotal();
        }
      }
    }
  }

  openDiscountWarranties() {
    if (!this.billOfMaterialModel['billOfMaterialId']) {
      return;
    }
    // let stocksAppliedForWarranty = this.billOfMaterialItemsFormArray.controls.filter(element => element.get('IsWarranty').value && !element.get('IsDeleted').value);
    // if (stocksAppliedForWarranty.length > 0) {
    const dialogReff = this.dialog.open(DiscountOnWarrantyMaintenanceModalComponent, {
      width: '800px',
      data: {
        header: 'Warranty Applied',
        userId: this.userData?.userId,
        billOfMaterialId: this.billOfMaterialModel['billOfMaterialId'],
      },
      disableClose: true
    });
    dialogReff.afterClosed().subscribe(result => {
      if (!result) return;
      this.getBillOfMaterialData();
    });
    // }
  }

  calculateLabourCharges() {
    if (!this.getBOMActionPermission(PermissionTypes.EDIT) && this.billOfMaterialModel?.billOfMaterialId) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    const dialogRemoveStockCode = this.dialog.open(BillOfMaterialScanModalComponent, {
      width: '450px',
      data: {
        buttons: {
          cancel: 'No',
          create: 'Yes'
        },
        message: 'Are you sure want to calculate the final servicing labour charges?',
        header: 'Labour Charge Confirmation',
      }, disableClose: true
    });

    dialogRemoveStockCode.afterClosed().subscribe(result => {
      if (!result) return;
      this.onCalculateLaborChargeAPI();
      this.rxjsService.setDialogOpenProperty(false);
    });
  }

  onCalculateLaborChargeAPI() {
    this.previousLaborCharge = this.billOfMaterialItemsFormArray.controls?.find(element => element.get('itemId').value?.toLowerCase() == this.billOfMaterialModel?.serviceLabourChargeItemId?.toLowerCase());
    this.crudService.get(ModulesBasedApiSuffix.TECHNICIAN,
      TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_LABOUR_CHARGE,
      undefined,
      false,
      prepareRequiredHttpParams({
        DistrictId: this.billOfMaterialModel['districtId'],
        AppointmentId: this.appointmentId,
        AppointmentLogId: this.appointmentLogId,
        itemPricingConfigId: this.billOfMaterialModel['itemPricingConfigId']
      })).subscribe(response => {
        this.rxjsService.setGlobalLoaderProperty(false);
        if (response.isSuccess == true && response.statusCode == 200 && response.resources) {
          // Related to Labour Charge
          let billOfMaterialItemsFormArray = this.billOfMaterialItemsFormArray;
          let stockDetails = billOfMaterialItemsFormArray.controls.find(element => element.get('itemId').value == response.resources.itemId);
          if (stockDetails == undefined) {
            let billOfMaterialLabourChargeFormGroup = this.formBuilder.group({
              checkBillOfMaterial: false,
              IsDeleted: false,
              billOfMaterialItemId: '',
              billOfMaterialId: this.billOfMaterialModel['billOfMaterialId'],
              stockTypeId: response.resources['stockTypeId'],
              stockType: response.resources['stockType'],
              itemId: response.resources['itemId'],
              itemCode: response.resources['itemCode'],
              itemName: response.resources['itemName'],
              kitConfigId: response.resources['kitConfigId'],
              kitTypeName: response.resources['kitTypeName'],
              invoice: 0,
              transfer: 0,
              used: 1,
              reserved: 0,
              request: 0,
              unitPrice: toRoundOffWithMathRound(response.resources['unitPrice']),
              subTotal: toRoundOffWithMathRound(response.resources['subTotal']),
              vATAmount: toRoundOffWithMathRound(response.resources['vat']),
              totalAmount: toRoundOffWithMathRound(response.resources['total']),
              createdUserId: this.userData?.userId,
              modifiedUserId: this.userData?.userId,
              IsWarranty: response.resources?.warranty?.isWarranty || false,
              WarrantyQty: response.resources?.warranty?.warrantyQty || null,
            });
            this.sortStockCodes(billOfMaterialLabourChargeFormGroup);
          } else {
            stockDetails.get('used').setValue(1);
            stockDetails.get('unitPrice').setValue(this.otherService.transformDecimal(toRoundOffWithMathRound(response.resources['unitPrice'])));
            stockDetails.get('subTotal').setValue(this.otherService.transformDecimal(toRoundOffWithMathRound(response.resources['subTotal'])));
            stockDetails.get('vATAmount').setValue(this.otherService.transformDecimal(toRoundOffWithMathRound(response.resources['vat'])));
            stockDetails.get('totalAmount').setValue(this.otherService.transformDecimal(toRoundOffWithMathRound(response.resources['total'])));
            this.onCalculateFinalTotal();
          }
          if (response.resources?.warranty?.isWarranty && response.resources?.warranty?.warrantyQty) {
            this.onAfterWarrantyLaborCharge(response?.resources?.warranty)
          }
        }
      });
  }

  onAfterWarrantyLaborCharge(warrantyItem) {
    let discountStockIndex = this.billOfMaterialItemsFormArray.controls.findIndex(element => element.get('itemId').value.toLowerCase() == warrantyItem['itemId'].toLowerCase());
    if (discountStockIndex == -1 && (warrantyItem['isWarranty'] || warrantyItem['isDiscountMaintenance'])) {
      let serialNumberlWarrantyItemFormGroup = this.createFormGroupToAddInGrid();
      serialNumberlWarrantyItemFormGroup.get('stockTypeId').setValue(warrantyItem['stockTypeId']);
      serialNumberlWarrantyItemFormGroup.get('stockType').setValue(warrantyItem['stockType']);
      serialNumberlWarrantyItemFormGroup.get('itemId').setValue(warrantyItem['itemId']);
      serialNumberlWarrantyItemFormGroup.get('itemCode').setValue(warrantyItem['itemCode']);
      serialNumberlWarrantyItemFormGroup.get('itemName').setValue(warrantyItem['itemName']);
      serialNumberlWarrantyItemFormGroup.get('WarrantyQty').setValue(warrantyItem['warrantyQty']);
      serialNumberlWarrantyItemFormGroup.get('unitPrice').setValue(-Math.abs(toRoundOffWithMathRound(warrantyItem['unitPrice'])));
      serialNumberlWarrantyItemFormGroup.get('subTotal').setValue(-Math.abs(toRoundOffWithMathRound(warrantyItem['subTotal'])));
      serialNumberlWarrantyItemFormGroup.get('vATAmount').setValue(-Math.abs(toRoundOffWithMathRound(warrantyItem['vat'])));
      serialNumberlWarrantyItemFormGroup.get('totalAmount').setValue(-Math.abs(toRoundOffWithMathRound(warrantyItem['total'])));
      serialNumberlWarrantyItemFormGroup.get('used').setValue(1);
      serialNumberlWarrantyItemFormGroup.get('WarrantyQty').setValue(warrantyItem['warrantyQty']);
      this.sortStockCodes(serialNumberlWarrantyItemFormGroup);
    } else if (discountStockIndex != -1 && (warrantyItem['isWarranty'] || warrantyItem['isDiscountMaintenance'])) {
      // Related to Discount Warrenties other than 1st time
      if (this.previousLaborCharge) {
        this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('unitPrice').setValue(-Math.abs(toRoundOffWithMathRound(this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('unitPrice').value) - +warrantyItem['unitPrice'] + this.otherService.transformCurrToNum(this.previousLaborCharge.get('unitPrice').value))));
        this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('subTotal').setValue(-Math.abs(toRoundOffWithMathRound(this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('subTotal').value) - +warrantyItem['subTotal'] + this.otherService.transformCurrToNum(this.previousLaborCharge.get('subTotal').value))));
        this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('vATAmount').setValue(-Math.abs(toRoundOffWithMathRound(this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('vATAmount').value) - +warrantyItem['vat'] + this.otherService.transformCurrToNum(this.previousLaborCharge.get('vATAmount').value))));
        this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('totalAmount').setValue(-Math.abs(toRoundOffWithMathRound(this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('totalAmount').value) - +warrantyItem['total'] + this.otherService.transformCurrToNum(this.previousLaborCharge.get('totalAmount').value))));
      } else {
        this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('unitPrice').setValue(-Math.abs(toRoundOffWithMathRound(this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('unitPrice').value) - +warrantyItem['unitPrice'])));
        this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('subTotal').setValue(-Math.abs(toRoundOffWithMathRound(this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('subTotal').value) - +warrantyItem['subTotal'])));
        this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('vATAmount').setValue(-Math.abs(toRoundOffWithMathRound(this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('vATAmount').value) - +warrantyItem['vat'])));
        this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('totalAmount').setValue(-Math.abs(toRoundOffWithMathRound(this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('totalAmount').value) - +warrantyItem['total'])));
      }
      this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('unitPrice').setValue(this.otherService.transformDecimal(this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('unitPrice').value));
      this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('subTotal').setValue(this.otherService.transformDecimal(this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('subTotal').value));
      this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('vATAmount').setValue(this.otherService.transformDecimal(this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('vATAmount').value));
      this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('totalAmount').setValue(this.otherService.transformDecimal(this.billOfMaterialItemsFormArray?.at(discountStockIndex).get('totalAmount').value));
      this.onCalculateFinalTotal();
    }
  }

  onNotSerialized(control, i) {
    if (control?.get('billOfMaterialItemId')?.value && control?.get('isNotSerialized')?.value == this.billOfMaterialItemsFormArray?.controls[i]?.get('isNotSerialized')?.value && control?.get('isNotSerialized')?.value && control?.get('stockType')?.value?.toLowerCase() == 'y' && this.billOfMaterialModel['technicianId']) {
      // return this.billOfMaterialModel?.bomQuotationItems ? (this.billOfMaterialModel?.bomQuotationItems[i]?.request == 0 && this.billOfMaterialModel?.bomQuotationItems[i]?.transfer == 0) : true;
      return this.billOfMaterialModel?.bomQuotationItems ? false : true;
    }
    return true;
  }

  getLightningAmt() {
    return (this.billOfMaterialModel['availableLightningDiscount'] < this.onCalculateLightningTotal()) ? this.billOfMaterialModel['availableLightningDiscount'] : this.onCalculateLightningTotal();
  }

  onValidateLightCover() {
    let condtion = false;
    const lightningAmt = this.getLightningAmt();
    this.billOfMaterialItemsFormArray.getRawValue()?.forEach((el, i) => {
      if (Math.abs(this.otherService.transformCurrToNum(el?.totalAmount)) > lightningAmt && this.billOfMaterialModel['lightningDiscountItemId'] == el?.itemId && el?.IsDeleted == false) {
        condtion = true;
      }
    })
    return condtion;
  }

  onValidateTechDiscount() {
    let condtion = false;
    const totalInclVat = this.onCaluateDiscountTotal(this.billOfMaterialModel['technicianDiscountItemId']);
    const totalStockInclVat = this.otherService.transformCurrToNum(this.billOfMaterialItemsFormArray.getRawValue()?.find(el => el?.itemId == this.billOfMaterialModel['technicianDiscountItemId'] && el?.IsDeleted == false)?.totalAmount);
    const totalAmt = Math.abs(this.otherService.transformCurrToNum(this.billOfMaterialForm?.get('bomInvoice.totalAmount')?.value));
    if (totalInclVat < Math.abs(totalStockInclVat) && totalAmt > 0.05) {
      condtion = true;
    }
    return condtion;
  }

  onValidateTechDiscountItems() {
    let condtion = false;
    const totalInclVat = this.onCaluateWithDiscountTotal();
    let totalStockInclVat = this.onCaluateWithoutDiscountTotal();
    const totalAmt = Math.abs(this.otherService.transformCurrToNum(this.billOfMaterialForm?.get('bomInvoice.totalAmount')?.value));
    if (totalInclVat > totalStockInclVat && totalAmt > 0.05) {
      condtion = true;
    }
    return condtion;
  }

  onValidateTechDiscountPercentage() {
    let condtion = false;
    const totalInclVat = this.onCaluateDiscountTotal(this.billOfMaterialModel['technicianDiscountItemId']);
    this.billOfMaterialItemsFormArray.getRawValue()?.forEach((el, i) => {
      const totalAmountIncVat = Math.abs(this.otherService.transformCurrToNum(this.billOfMaterialForm?.get('bomInvoice.totalAmount')?.value));
      if (this.billOfMaterialModel['technicianDiscountItemId'] == el?.itemId && el?.IsDeleted == false && this.billOfMaterialModel?.technicialCallDiscountRequestId && this.billOfMaterialModel?.technicialCallDiscountRequestStatus?.toLowerCase() == 'pending') {
        const discount: any = (Math.abs(totalAmountIncVat) * 100) / totalInclVat;
        if (Math.abs(toRoundOffWithMathRound(discount)) > +this.billOfMaterialModel?.technicalDiscountPercentage) {
          condtion = true;
        }
      }
    })
    return condtion;
  }

  onValidateLightnCoverMsg() {
    const lightningAmt = this.getLightningAmt();
    return this.snackbarService.openSnackbar(`Please enter lighting cover amount(Incl. Vat) is less than or equal to ${lightningAmt}`);
  }

  // onValidateTechDiscountCoverMsg() {
  //   const discountAmt = this.onCaluateDiscountTotal(this.billOfMaterialModel.technicianDiscountItemId);
  //   return this.snackbarService.openSnackbar(`Please enter discount amount(Incl. Vat) is less than or equal to ${discountAmt}`);
  // }

  onValidateDiscountCoverMsg(itemId: string) {
    const discountAmt = this.onCaluateDiscountTotal(itemId);
    return this.snackbarService.openSnackbar(`Please enter discount amount(Incl. Vat) is less than or equal to ${discountAmt}`);
  }

  onValidateDoaApprovalMsg() {
    return this.snackbarService.openSnackbar("Discount item DOA approval not completed")
  }

  onValidateNotSerialized() {
    let condtion = false;
    this.billOfMaterialItemsFormArray.getRawValue()?.forEach((el, i) => {
      if ((this.billOfMaterialModel['isPRCall'] && el?.isNotSerialized && el?.reserved > 1) || (el?.isNotSerialized && el?.reserved > 1)) {
        condtion = true;
      }
    })
    return condtion;
  }

  updateBillOfMaterial() {
    if ((!this.getBOMActionPermission(PermissionTypes.EDIT) && this.billOfMaterialModel?.billOfMaterialId) || (!this.getBOMActionPermission(PermissionTypes.ADD) && !this.billOfMaterialModel?.billOfMaterialId)) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    if (this.billOfMaterialItemsFormArray.invalid) {
      this.billOfMaterialItemsFormArray.markAllAsTouched();
      return;
    }
    if (this.onValidateLightCover()) {
      return this.onValidateLightnCoverMsg();
    }
    if (this.onValidateTechDiscount() && this.callType == '2') {
      // return this.onValidateTechDiscountCoverMsg();
      return this.onValidateDiscountCoverMsg(this.billOfMaterialModel.technicianDiscountItemId);
    }
    if (this.onValidateTechDiscountPercentage()) {
      return this.onValidateDoaApprovalMsg();
    }
    if (this.onValidateTechDiscountItems() && this.callType == '2') {
      return this.snackbarService.openSnackbar(`Please enter discount amount(Incl. Vat) is less than or equal to ${this.onCaluateWithoutDiscountTotal()}`);
    }
    this.billOfMaterialForm?.markAsUntouched();
    this.billOfMaterialForm.value.TechnicialCallDiscountRequestApprovalId = this.TechnicialCallDiscountRequestApprovalId

    let submit$ = [];
    this.stockExistError = false;
    const reqBomObj = {
      ...this.billOfMaterialForm.value
    };
    reqBomObj['differenceAmount'] = typeof reqBomObj['differenceAmount'] == 'string' && reqBomObj['differenceAmount'] ? this.otherService.transformCurrToNum(reqBomObj['differenceAmount']) : 0;
    reqBomObj['totalAmount'] = typeof reqBomObj['totalAmount'] == 'string' && reqBomObj['totalAmount'] ? this.otherService.transformCurrToNum(reqBomObj['totalAmount']) : 0;
    reqBomObj['bomInvoice'].subTotal = typeof reqBomObj['bomInvoice'].subTotal == 'string' && reqBomObj['bomInvoice'].subTotal ? this.otherService.transformCurrToNum(reqBomObj['bomInvoice'].subTotal) : 0;
    reqBomObj['bomInvoice'].vatAmount = typeof reqBomObj['bomInvoice'].vatAmount == 'string' && reqBomObj['bomInvoice'].vatAmount ? this.otherService.transformCurrToNum(reqBomObj['bomInvoice'].vatAmount) : 0;
    reqBomObj['bomInvoice'].totalAmount = typeof reqBomObj['bomInvoice'].totalAmount == 'string' && reqBomObj['bomInvoice'].totalAmount ? this.otherService.transformCurrToNum(reqBomObj['bomInvoice'].totalAmount) : 0;
    reqBomObj['totalAmount'] = reqBomObj['bomInvoice'].totalAmount;
    reqBomObj?.billOfMaterialItems?.map(el => {
      if (el.itemId) {
        el.unitPrice = el?.unitPrice && typeof el?.unitPrice == 'string' ? this.otherService.transformCurrToNum(el?.unitPrice) : el?.unitPrice;
        el.subTotal = el?.subTotal && typeof el?.subTotal == 'string' ? this.otherService.transformCurrToNum(el?.subTotal) : el?.subTotal;
        el.vATAmount = el?.vATAmount && typeof el?.vATAmount == 'string' ? this.otherService.transformCurrToNum(el?.vATAmount) : el?.vATAmount;
        el.totalAmount = el?.totalAmount && typeof el?.totalAmount == 'string' ? this.otherService.transformCurrToNum(el?.totalAmount) : el?.totalAmount;
      }
      return el;
    });
    if (this.billOfMaterialModel['billOfMaterialId'] == undefined) {
      submit$.push(this.crudService.create(
        ModulesBasedApiSuffix.TECHNICIAN,
        TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL,
        reqBomObj
      ));
    } else {
      submit$.push(this.crudService.update(
        ModulesBasedApiSuffix.TECHNICIAN,
        TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL,
        reqBomObj
      ));
    }
    forkJoin(submit$).subscribe((response: IApplicationResponse[]) => {
      this.rxjsService.setGlobalLoaderProperty(false);
      response.forEach((respObj: IApplicationResponse, ix: number) => {
        if (respObj.isSuccess) {
          switch (ix) {
            case 0:
              this.serialNumberDataLocally = [];
              this.previousLaborCharge = {};
              this.getBillOfMaterialData();
              this.billOfMaterialForm.get('differenceAmount').reset();
              this.billOfMaterialForm.get('bomInvoice').reset();
              break;
          }
        }
      });
    });
  }

  onStatucCodeSelected(value, type) {
    let stockItemData;
    if (type === 'stockCode') {
      stockItemData = this.filteredStockCodes.find(x => x.itemCode === value);
      if (!stockItemData) {

      }
      else {
        this.isStockCodeBlank = true;
        this.stockCodeDescriptionForm.get('stockDescription').setValue(stockItemData.displayName, { emitEvent: false });
        this.stockCodeDescriptionForm.get('stockUnitPriceExcl').setValue(stockItemData.costPrice, { emitEvent: false });
        this.stockCodeDescriptionForm.get('itemId').setValue(stockItemData.id);
        this.stockCodeDescriptionForm.get('stockTypeId').setValue(stockItemData.stockTypeId);
        this.stockCodeDescriptionForm.get('kitConfigId').setValue(stockItemData.kitConfigId);
        this.stockCodeDescriptionForm.get('kitTypeName').setValue(stockItemData.kitTypeName);
        this.stockCodeDescriptionForm.get('systemTypeId').setValue(stockItemData.systemTypeId);
        this.stockCodeDescriptionForm.get('itemPricingConfigId').setValue(stockItemData.itemPricingConfigId);
        this.stockCodeDescriptionForm.get('isNotSerialized').setValue(stockItemData.isNotSerialized);
      }
    } else if (type === 'stockDescription') {
      stockItemData = this.filteredStockDescription.find(x => x.displayName === value);
      if (!stockItemData) {

      }
      else {
        this.isStockDescriptionSelected = true;
        this.stockCodeDescriptionForm.get('stockCode').setValue(stockItemData.itemCode, { emitEvent: false });
        this.stockCodeDescriptionForm.get('stockUnitPriceExcl').setValue(stockItemData.costPrice, { emitEvent: false });
        this.stockCodeDescriptionForm.get('itemId').setValue(stockItemData.id);
        this.stockCodeDescriptionForm.get('stockTypeId').setValue(stockItemData.stockTypeId);
        this.stockCodeDescriptionForm.get('kitConfigId').setValue(stockItemData.kitConfigId);
        this.stockCodeDescriptionForm.get('kitTypeName').setValue(stockItemData.kitTypeName);
        this.stockCodeDescriptionForm.get('systemTypeId').setValue(stockItemData.systemTypeId);
        this.stockCodeDescriptionForm.get('itemPricingConfigId').setValue(stockItemData.itemPricingConfigId);
        this.stockCodeDescriptionForm.get('isNotSerialized').setValue(stockItemData.isNotSerialized);
      }
    }
  }

  openKitDetailsModal(itemCode: any, kitConfigId: any): void {
    if (!itemCode || !kitConfigId) {
      return;
    }
    this.stockCode = itemCode;
    let params = new HttpParams().set('KitConfigId', kitConfigId);
    this.crudService.get(ModulesBasedApiSuffix.TECHNICIAN, TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_STOCK_KIT_DETAILS, undefined, true, params)
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200) {
          this.openKitDetailsDialog = true;
          this.modalDetails = response.resources;
          this.rxjsService.setGlobalLoaderProperty(false);
        }
      });
  }

  openStockSwap() {
    if (!this.getBOMActionPermission(PermissionTypes.EDIT) && this.billOfMaterialModel?.billOfMaterialId) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    this.router.navigate(['/customer/manage-customers/stock-swap-request'], {
      queryParams: {
        callInitiationId: this.callInitiationId,
        quotationVersionId: this.quotationVersionId,
        partitionId: this.partitionId,
        customerId: this.customerId,
        isInstallPreCheck: this.isInstallPreCheck,
        isUpselling: this.isUpselling,
        isCounterSale: this.isCounterSale,
        isFeedback: this.isFeedback,
        isNKACustomer: this.isNKACustomer,
        callType: this.callType,
        customerAddressId: this.customerAddressId,
        billOfMaterialId: this.billOfMaterialModel ? this.billOfMaterialModel.billOfMaterialId : null,
        districtId: this.billOfMaterialModel ? this.billOfMaterialModel.districtId : null
      }
    });
  }

  findRadioCall() {
    let findArray = [];
    this.billOfMaterialModel?.bomQuotationItems?.forEach(el => {
      if ((el?.invoice > 0 || el?.reserved > 0) && el?.isDecoder) {
        findArray?.push(true);
      }
    });
    return findArray?.length;
  }

  getTransferOrRequestCountIsPresent() {
    let findArray = [];
    this.billOfMaterialModel?.bomQuotationItems?.forEach(el => {
      if ((el?.request > 0 || el?.transfer > 0)) {
        findArray?.push(true);
      }
    });
    return findArray?.length;
  }

  checkInvoiceValidation() {
    if (!this.getBOMActionPermission(PermissionTypes.EDIT) && this.billOfMaterialModel?.billOfMaterialId) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    if (!this.billOfMaterialModel['technicianId']) {
      return this.snackbarService.openSnackbar('Scheduling is required for the job');
    }
    if (this.callType != '1' && !this.isUpselling && !this.isCounterSale && this.getTransferOrRequestCountIsPresent()) {
      return this.snackbarService.openSnackbar('Items are still in request/transfer state, cannot proceed further.');
    }
    if (this.callType == '1' && (!this.billOfMaterialModel['isRadio'] && !this.findRadioCall())) {
      if (this.getNotificationDialogOpened()) {
        return;
      }
      this.openConfigDialog({ title: 'Notification', message: `Unable to invoice the job as no radio is installed` });
      return;
    }
    const totalAmt = Math.abs(this.otherService.transformCurrToNum(this.billOfMaterialForm?.get('bomInvoice.totalAmount')?.value));
    if (+totalAmt < 0) {
      this.openNegativeBOMDialogValidation();
      return;
    } else {
      this.onAfterJobCardValidationAPI();
    }
  }

  onAfterJobCardValidationAPI() {
    this.rxjsService.setGlobalLoaderProperty(true);
    this.billOfMaterialForm?.markAsUntouched();
    if (this.jobCardAcceptanceSubscription && !this.jobCardAcceptanceSubscription.closed) {
      return;
    }
    this.rxjsService.setGlobalLoaderProperty(true);
    this.jobCardAcceptanceSubscription = this.crudService.get(
      ModulesBasedApiSuffix.TECHNICIAN,
      TechnicalMgntModuleApiSuffixModels.JOB_CARD_ACCEPTANCE_VALIDATION, undefined, false, prepareRequiredHttpParams({
        CallInitiationId: this.callInitiationId,
        modifiedUserId: this.userData?.userId,
      }))
      .subscribe((res: IApplicationResponse) => {
        if (res.isSuccess == true && res.statusCode == 200) {
          if (res?.resources?.validateMessage && !res?.resources?.isSuccess) {
            this.openConfigDialog({ title: 'Notification', message: res?.resources?.validateMessage });
            this.rxjsService.setGlobalLoaderProperty(false);
            return;
          } else if (this.billOfMaterialModel?.isDealerCall && res?.resources?.isSuccess && res?.resources?.validateMessage) {
            this.snackbarService.openSnackbar(res?.resources?.validateMessage, ResponseMessageTypes.SUCCESS);
            this.navigateToPage();
            this.rxjsService.setGlobalLoaderProperty(false);
            return;
          }
          else if (res.resources.isSuccess) {
            // call RATE_OUR_SERVICE_CALL before navigating
            if (!this.isFeedback) {
              this.onDiagnosisSubmit();
            } else {
              this.onNavigateToJobCardAcceptance();
            }
          }
        }
      });
  }

  onDiagnosisSubmit() {
    this.rxjsService.setGlobalLoaderProperty(true);
    this.crudService.update(
      ModulesBasedApiSuffix.TECHNICIAN,
      TechnicalMgntModuleApiSuffixModels.CALL_INITIATION_DIAGNOSIS_UPDATE,
      {
        callInitiationId: this.callInitiationId,
        modifiedUserId: this.userData?.userId,
      }
    ).subscribe(res => {
      this.rxjsService.setGlobalLoaderProperty(true);
      this.onRateOurServiceSubmit();
    });
  }

  onRateOurServiceSubmit() {
    this.crudService.create(
      ModulesBasedApiSuffix.TECHNICIAN,
      TechnicalMgntModuleApiSuffixModels.RATE_OUR_SERVICE_CALL,
      {
        callInitiationId: this.callInitiationId,
        source: 'Web',
        createdUserId: this.userData?.userId,
      }
    ).subscribe(response => {
      this.onNavigateToJobCardAcceptance();
    });
  }

  onNavigateToJobCardAcceptance() {
    this.rxjsService.setGlobalLoaderProperty(true);
    this.router.navigate(['/customer', 'manage-customers', 'bill-of-material', 'job-card-acceptance'], {
      queryParams: {
        billOfMaterialId: this.billOfMaterialModel ? this.billOfMaterialModel.billOfMaterialId : null,
        customerId: this.customerId,
        addressId: this.customerAddressId,
        partitionId: this.partitionId,
        quotationVersionId: this.quotationVersionId,
        callInitiationId: this.callInitiationId,
        callType: this.callType,
        appointmentId: this.appointmentId,
        isUpselling: this.isUpselling,
        isFeedback: this.isFeedback,
      }
    });
  }

  openConfigDialog(dialogData) {
    const dialogRef = this.dialog.open(ConfirmDialogPopupComponent, {
      width: "550px",
      data: { ...dialogData, isConfirm: false, isClose: false, msgCenter: true, isAlert: true },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      } else {
        return;
      }
    });
  }

  openNegativeBOMDialogValidation() {
    const dialogReff = this.dialog.open(BillOfMaterialValidationModalComponent, {
      width: '450px',
      data: {
        buttons: {
          cancel: 'Cancel',
          create: 'Apply'
        },
        message: "BOM Total value is negative. Are you sure you want to continue?",
        header: 'Alert',
      },
      disableClose: true
    });
    dialogReff.afterClosed().subscribe(result => {
      if (result) {
        this.onAfterJobCardValidationAPI();
      } else {
        return;
      }
    });
  }

  openCalculator() {
    window.open("Calculator:///", "_self");
  }

  isKitConfigId(control) {
    return control?.get('kitConfigId')?.value;
  }

  isNotSerialized(control) {
    return control?.get('isNotSerialized')?.value;
  }

  navigateAfterPrCall() {
    this.alertDialog = false;
    this.navigateToPage();
  }

  getSerialNoLocally(control) {
    control?.get('billOfMaterialItemDetails')?.value?.forEach(el => {
      this.serialNumbersData.push({ serialNo: el?.serialNumber });
    });
  }

  openSerialNumbers(control) {
    if (!control?.get('billOfMaterialItemId')?.value || !this.billOfMaterialModel['billOfMaterialId']) {
      this.serialNumbersData = [];
      this.getSerialNoLocally(control);
      this.openSerialNumbersDialog = true;
      return;
    }
    this.serialNumbersData = [];
    this.crudService.get(
      ModulesBasedApiSuffix.TECHNICIAN,
      TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_ITEM_DETAILS,
      undefined,
      false,
      prepareGetRequestHttpParams('', '', {
        BillOfMaterialId: this.billOfMaterialModel['billOfMaterialId'],
        BillOfMaterialItemId: control?.get('billOfMaterialItemId')?.value,
      })
    ).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess == true && response.statusCode == 200) {
        this.serialNumbersData = response.resources;
        this.getSerialNoLocally(control);
        this.openSerialNumbersDialog = true;
        this.rxjsService.setGlobalLoaderProperty(false);
      }
    })
  }

  autoSaveAlertNavigate() {
    if (this.billOfMaterialForm.touched || this.billOfMaterialItemsFormArray.touched) {
      const message = `You have unsaved changes! Do you want to save this?`;
      const dialogData = new ConfirmDialogModel("Confirm Action", message);
      const autoSaveAlertDialog = this.dialogService.open(PrimengConfirmDialogPopupComponent, {
        showHeader: false,
        width: "450px",
        data: { ...dialogData, msgCenter: true },
        baseZIndex: 5000,
      });
      autoSaveAlertDialog.onClose.subscribe(dialogResult => {
        if (dialogResult === true) {
          if (!this.billOfMaterialForm.get('stockCodeSerialNumber').value) {
            this.billOfMaterialForm.get('stockCodeSerialNumber').clearValidators();
            this.billOfMaterialForm.get('stockCodeSerialNumber').updateValueAndValidity();
          }
          if (this.billOfMaterialForm.invalid) {
            this.billOfMaterialForm.markAllAsTouched();
            return false;
          }
          this.updateBillOfMaterial();
          // return true
        }
      })
    }
  }

  canDeactivate() {
    // autosave functionality starts here
    if (this.billOfMaterialForm.touched || this.billOfMaterialItemsFormArray.touched) {
      const message = `You have unsaved changes! Do you want to save this?`;
      const dialogData = new ConfirmDialogModel("Confirm Action", message);
      const canDeactivateDialog = this.dialogService.open(PrimengConfirmDialogPopupComponent, {
        showHeader: false,
        width: "450px",
        data: dialogData,
        baseZIndex: 5000,
      });
      return canDeactivateDialog.onClose.pipe(map(dialogResult => {
        if (dialogResult === true) {
          this.autoSubmitClick()
          if (!this.billOfMaterialForm.get('stockCodeSerialNumber').value) {
            this.billOfMaterialForm.get('stockCodeSerialNumber').clearValidators();
            this.billOfMaterialForm.get('stockCodeSerialNumber').updateValueAndValidity();
          }
          if (this.billOfMaterialForm.invalid) {
            this.billOfMaterialForm.markAllAsTouched();
            return false;
          }
          return true;

        } else if (dialogResult === false) {
          return true;
        }
      }))
    } else {
      return true;
    }
    // autosave functionality ends here
  }

  autoSubmitClick() {
    let element: HTMLElement = document.querySelector('.autoSave') as HTMLElement;
    element.click();
  }

  openConfirmationDialog() {
    if (!this.getBOMActionPermission(PermissionTypes.EDIT) && this.billOfMaterialModel?.billOfMaterialId) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    this.isGRVConfirmationDialog = false;
    const isNotContainsYStock = this.billOfMaterialItemsFormArray.getRawValue()?.filter(bill => bill.stockType?.toLowerCase() == 'y');
    const isMovedTransfer = this.billOfMaterialItemsFormArray.getRawValue()?.filter(bill => bill.stockType?.toLowerCase() == 'y' && +bill.transfer > 0);
    if (!this.billOfMaterialItemsFormArray.getRawValue()?.length || !isNotContainsYStock?.length) {
      this.isGRVConfirmationDialog = false;
      this.snackbarService.openSnackbar("Unable to process GRV, no stock available");
      return;
    } else if (!isMovedTransfer?.length) {
      this.snackbarService.openSnackbar("Unable to process GRV, as there is no stock on transferred");
      return;
    } else if (!this.billOfMaterialModel?.billOfMaterialId) {
      this.snackbarService.openSnackbar("Please apply the Bill of Material")
      return;
    } else if (this.billOfMaterialForm.touched || this.billOfMaterialItemsFormArray.touched) {
      this.autoSaveAlertNavigate();
      return;
    } else {
      this.isGRVConfirmationDialog = true;
    }
  }

  createServiceCall() {
    if (!this.getBOMActionPermission(PermissionTypes.EDIT) && this.billOfMaterialModel?.billOfMaterialId) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    const reqObj = {
      callInitiationId: this.callInitiationId,
      isSameAppointment: true,
      createdUserId: this.userData?.userId,
      newCallInitiationId: this.newCallInitiationId || this.billOfMaterialModel?.derivedCallInitiationId || null,
      itemId: this.searchScannedItemResponse?.itemId,
      qty: this.searchScannedItemResponse?.qty,
      SerialNumber: this.billOfMaterialForm.get('stockCodeSerialNumber').value,
      itemPricingConfigId: this.searchScannedItemResponse?.itemPricingConfigId,
    };
    this.isServiceCallSumbmit = true;
    this.crudService.create(ModulesBasedApiSuffix.TECHNICIAN, TechnicalMgntModuleApiSuffixModels.SERVICE_CALL_INITIATION_EXISTING_CALL, reqObj)
      .subscribe((res: IApplicationResponse) => {
        this.isServiceCallSumbmit = false;
        if (res?.isSuccess && res?.statusCode == 200) {
          this.newCallInitiationId = res?.resources;
          this.billOfMaterialForm.get('stockCodeSerialNumber').setValue('');
          this.isScanServiceCallDialog = false;
        }
      })
  }

  getDisabledCheckbox() {
    return this.getDisabledForm() || this.billOfMaterialItemsFormArray?.controls?.length == 0 || (!this.getBOMActionPermission(PermissionTypes.EDIT) && this.billOfMaterialModel?.billOfMaterialId) || (!this.getBOMActionPermission(PermissionTypes.ADD) && !this.billOfMaterialModel?.billOfMaterialId);
  }

  getDisabledForm() {
    return this.billOfMaterialModel?.isFaultyReturn || this.isVoid || (!this.getBOMActionPermission(PermissionTypes.EDIT) && this.billOfMaterialModel?.billOfMaterialId) || (!this.getBOMActionPermission(PermissionTypes.ADD) && !this.billOfMaterialModel?.billOfMaterialId) ? true : null;
  }

  getDisabledCounterSales() {
    return this.billOfMaterialModel?.isCounterSale;
  }

  getProcessGVDisabledForm() {
    return this.billOfMaterialModel?.isFaultyReturn || this.isVoid || !this.billOfMaterialModel?.stockOrderNumber || (!this.getBOMActionPermission(PermissionTypes.EDIT) && this.billOfMaterialModel?.billOfMaterialId) || (!this.getBOMActionPermission(PermissionTypes.ADD) && !this.billOfMaterialModel?.billOfMaterialId);
  }

  /* Navigate To GRV */
  navigateToGRVPage() {
    if (!this.getBOMActionPermission(PermissionTypes.EDIT) && this.billOfMaterialModel?.billOfMaterialId) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR);
    }
    if (this.billOfMaterialModel.stockOrderNumber == null) return;
    this.router.navigate(['/technical-management', 'technician-goods-return', 'add-edit'], {
      queryParams: {
        id: null,
        type: 'billOfMaterial',
        stockOrderNumber: this.billOfMaterialModel.stockOrderNumber,
        stockOrderId: this.billOfMaterialModel.stockOrderId,
        callInitiationId: this.callInitiationId,
      }, skipLocationChange: true
    });
  }
}
